<template>
  <v-container color="primary" class="pa-4" style="max-width: 1280px;">
    <!-- Statistics Widgets -->
    <v-layout row wrap class="mb-4" v-if="statistics">
        <v-flex xs12 sm6 md2 lg2>
            <v-card class="mx-2 my-2 text-xs-center blue lighten-5">
                <v-card-text>
                    <div class="display-1 font-weight-bold blue--text text--darken-4">{{ statistics.total }}</div>
                    <div class="caption blue--text text--darken-2 font-weight-bold">Total Embarques</div>
                </v-card-text>
            </v-card>
        </v-flex>
        <v-flex xs12 sm6 md2 lg2>
            <v-card class="mx-2 my-2 text-xs-center orange lighten-5">
                <v-card-text>
                    <div class="display-1 font-weight-bold orange--text text--darken-4">{{ statistics.en_planta }}</div>
                    <div class="caption orange--text text--darken-2 font-weight-bold">En Planta</div>
                </v-card-text>
            </v-card>
        </v-flex>
        <v-flex xs12 sm6 md2 lg2>
            <v-card class="mx-2 my-2 text-xs-center red lighten-5">
                <v-card-text>
                    <div class="display-1 font-weight-bold red--text text--darken-4">{{ statistics.en_retraso }}</div>
                    <div class="caption red--text text--darken-2 font-weight-bold">En Retraso</div>
                </v-card-text>
            </v-card>
        </v-flex>
        <v-flex xs12 sm6 md2 lg2>
            <v-card class="mx-2 my-2 text-xs-center purple lighten-5">
                <v-card-text>
                    <div class="display-1 font-weight-bold purple--text text--darken-4">{{ statistics.liberados }}</div>
                    <div class="caption purple--text text--darken-2 font-weight-bold">Liberados</div>
                </v-card-text>
            </v-card>
        </v-flex>
        <v-flex xs12 sm6 md2 lg2>
            <v-card class="mx-2 my-2 text-xs-center green lighten-5">
                <v-card-text>
                    <div class="display-1 font-weight-bold green--text text--darken-4">{{ statistics.completados }}</div>
                    <div class="caption green--text text--darken-2 font-weight-bold">Completados</div>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>

    <!-- Calendar as main element -->
    <v-card class="rounded-lg elevation-4 overflow-hidden">
      <v-toolbar flat color="white" class="border-bottom">
        <v-icon color="primary" class="mr-3">event_available</v-icon>
        <v-toolbar-title class="headline font-weight-bold primary--text">
          Calendario de Ventanas de Embarques
        </v-toolbar-title>
        <v-btn icon color="primary" @click="fillCalendars(currentDate, currentDate)" :loading="loadingShippingWindows" class="ml-2">
          <v-icon>refresh</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-switch
          v-model="mostrarCancelados"
          label="Mostrar cancelados"
          hide-details
          class="ma-0 pa-0 mr-4"
        ></v-switch>
        <v-select
        v-if="enableAdvancedShipments"
          v-model="filtroTipoMovimiento"
          :items="[
            { text: 'Todos', value: 'TODOS' },
            { text: 'Solo Embarques', value: 'EMBARQUE' },
            { text: 'Solo Recepciones', value: 'RECEPCION' }
          ]"
          item-text="text"
          item-value="value"
          dense
          outlined
          hide-details
          class="ma-0 pa-0 mr-4"
          style="max-width: 180px"
        ></v-select>
        <v-btn text color="primary" @click="dialogShareProgram = true" class="text-none ml-2 font-weight-bold" style="border-radius: 8px;">
          <v-icon left>share</v-icon>
          Compartir Programa
        </v-btn>
      </v-toolbar>

      <v-divider></v-divider>

      <v-card-text class="pa-6">
        <div class="d-flex align-center justify-space-between mb-6 flex-wrap">
          <div class="d-flex align-center">
            <v-btn small depressed color="primary lighten-4" @click="goPrev()" :loading="loadingShippingWindows" class="mr-2">
              <v-icon color="primary">chevron_left</v-icon>
            </v-btn>
            <v-menu
              ref="menuVentana2"
              v-model="menuVentana2"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
              :z-index="2000"
            >
              <template v-slot:activator="{ on, attrs }">
                <div class="date-display px-4 py-2 rounded-pill lighten-5 primary--text font-weight-bold pointer d-flex align-center" v-bind="attrs" v-on="on">
                  <v-icon color="primary">calendar_today</v-icon>
                  {{ form.fechaVentana }}
                </div>
              </template>
              <v-date-picker
                ref="picker"
                v-model="form.fechaVentana"
                :locale="$t('region')"
                @change="saveDate"
                @input="menuVentana2 = false"
                color="primary"
              />
            </v-menu>

            <v-btn small depressed color="primary lighten-4" @click="goNext" :loading="loadingShippingWindows" class="ml-2">
              <v-icon color="primary">chevron_right</v-icon>
            </v-btn>
          </div>

          <div class="legend d-flex align-center mt-2 mt-sm-0 flex-wrap">
            <div class="legend-item d-flex align-center mr-4 mb-2">
              <div class="legend-box programada-event mr-2"></div>
              <span class="caption font-weight-medium">Programada</span>
            </div>
            <div class="legend-item d-flex align-center mr-4 mb-2">
              <div class="legend-box confirmada-event mr-2"></div>
              <span class="caption font-weight-medium">Confirmada</span>
            </div>
            <div class="legend-item d-flex align-center mr-4 mb-2">
              <div class="legend-box ensitio-event mr-2"></div>
              <span class="caption font-weight-medium">En Sitio</span>
            </div>
            <div class="legend-item d-flex align-center mr-4 mb-2">
              <div class="legend-box enproceso-event mr-2"></div>
              <span class="caption font-weight-medium">En Proceso</span>
            </div>
            <div class="legend-item d-flex align-center mr-4 mb-2">
              <div class="legend-box liberada-event mr-2"></div>
              <span class="caption font-weight-medium">Liberada</span>
            </div>
            <div class="legend-item d-flex align-center mr-4 mb-2">
              <div class="legend-box completada-event mr-2"></div>
              <span class="caption font-weight-medium">Completada</span>
            </div>
            <div class="legend-item d-flex align-center mb-2">
              <div class="legend-box cancelada-event mr-2"></div>
              <span class="caption font-weight-medium">Cancelada</span>
            </div>
          </div>
        </div>

        <div class="calendar-container-wrapper">
          <v-layout row wrap class="calendar-grid">
            <v-flex v-for="(item, index) in calendars" :key="index" xs12 class="calendar-column border-right border-left">
              <div class="calendar-header-title py-3 text-center primary--text font-weight-bold border-bottom">
                {{ item.name }}
              </div>
              <v-calendar
                ref="calendarwe"
                v-model="currentDate"
                hide-header
                :value="today"
                :weekdays="[1, 2, 3, 4, 5, 6, 0]"
                type="day"
                :locale="$t('region')"
                :interval-minutes="30"
                :interval-count="numberSlots"
                :first-interval="0"
                :events="item.events"
                :interval-format="intervalFormat"
                @click:time="agregarNewEventoToCalendar($event, index, item.id)"
                class="custom-calendar-style"
              >
                <template v-slot:interval="{ hour, minute }">
                  <div class="interval-label text-center caption grey--text text--darken-1">
                    {{ hour.toString().padStart(2, '0') }}:{{ minute.toString().padStart(2, '0') }}
                  </div>
                </template>
                <template v-slot:dayBody="{ date, timeToY, minutesToPixels }">
                  <template v-for="event in eventsMap[index][date]">
                    <v-tooltip v-if="shouldShowEvent(event)" bottom :key="event.id + '-' + event.time">
                      <template v-slot:activator="{ on, attrs }">
                        <div
                          v-bind="attrs"
                          v-on="on"
                          :class="[
                            'my-event-folder',
                            'with-time',
                            getMovementClass(event)
                          ]"
                          :style="{
                            top: timeToY(event.time) + 'px',
                            height: minutesToPixels(event.duration) + 'px',
                            borderLeftColor: getMovementBorderColor(event),
                            borderLeftWidth: '4px'
                          }"
                          @click="open(event)"
                        >
                          <div :class="['folder-tab', getStatusClass(event.title)]">
                            <v-icon v-if="event.title === 'COMPLETADA'" x-small color="white" class="mr-1" style="font-size: 12px;">done_all</v-icon>
                            <v-icon v-else-if="event.title === 'EN_PROCESO'" x-small color="white" class="mr-1" style="font-size: 12px;">pending</v-icon>
                            <!-- REQ-002: Indicadores visuales de tipo de movimiento -->
                            <v-icon
                              v-else-if="event.tipo_movimiento === 'EMBARQUE'"
                              x-small
                              color="white"
                              class="mr-1"
                              style="font-size: 12px;"
                              title="Embarque (Salida)"
                            >
                              arrow_upward
                            </v-icon>
                            <v-icon
                              v-else-if="event.tipo_movimiento === 'RECEPCION'"
                              x-small
                              color="white"
                              class="mr-1"
                              style="font-size: 12px;"
                              title="Recepción (Entrada)"
                            >
                              arrow_downward
                            </v-icon>
                            <span class="folder-tab-text">{{ event.title }}</span>
                            <v-tooltip top v-if="(event.title === 'EN_PROCESO' || event.title === 'LIBERADA') && isTimeExceeded(event)">
                              <v-icon slot="activator" x-small color="red accent-2" class="ml-1 blink-alert" style="font-size: 14px;">warning</v-icon>
                              <span>¡Tiempo de carga excedido!</span>
                            </v-tooltip>
                            <v-tooltip top v-if="enableAdvancedShipments && hasPendingDocuments(event)">
                              <v-icon slot="activator" x-small color="amber darken-2" class="ml-1" style="font-size: 14px;">description</v-icon>
                              <span>Documentos pendientes</span>
                            </v-tooltip>
                          </div>
                          <div :class="['folder-body', getStatusClass(event.title)]">
                            <div class="folder-content" style="display: flex; flex-direction: column; height: 100%; justify-content: space-between; text-align: left; gap: 8px;">
                              <!-- REQ-002: Etiqueta de tipo de movimiento -->
                              <div v-if="enableAdvancedShipments && event.tipo_movimiento" class="d-flex align-center gap-1">
                                <v-chip
                                  x-small
                                  :class="getMovimientoChipClass(event.title)"
                                  label
                                >
                                  {{ event.tipo_movimiento === 'EMBARQUE' ? 'Embarque' : 'Recepción' }}
                                </v-chip>
                                <v-chip
                                  v-if="event.is_internal"
                                  x-small
                                  color="success"
                                  text-color="white"
                                  label
                                  title="Asignación Interna"
                                >
                                  Interno
                                </v-chip>
                              </div>
                              <div class="event-client-name font-weight-bold" v-if="event.client_name" style="font-size: 1rem; line-height: 1.2; word-break: break-word;">
                                {{ event.client_name }}
                              </div>
                              <div v-if="event.invited_company" class="caption" style="opacity: 0.85; font-size: 0.80rem; font-style: italic; word-break: break-word;">
                                {{ event.invited_company }}
                              </div>
                              <div class="caption mt-auto pt-1 font-weight-medium" style="opacity: 0.95; font-size: 0.90rem;">
                                {{ event.time }} <span v-if="event.duration">({{ event.duration }} min)</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                      <span>{{ event.title }} ({{ event.time }})<span v-if="event.client_name"> - {{ event.client_name }}</span></span>
                    </v-tooltip>
                  </template>
                </template>
              </v-calendar>
            </v-flex>
          </v-layout>
        </div>
      </v-card-text>

    </v-card>

    <!-- Dialog for Sharing Program -->
    <v-dialog v-model="dialogShareProgram" max-width="500px">
      <v-card class="rounded-xl overflow-hidden">
        <v-toolbar flat dark color="primary">
          <v-icon left>email</v-icon>
          <v-toolbar-title class="font-weight-bold">Compartir Programa</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogShareProgram = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pa-4">
          <v-alert :value="true" type="info" outline icon="info" class="mb-4">
            Ingresa los correos electrónicos para enviar el programa de embarques de la fecha: <b>{{ form.fechaVentana }}</b>.
          </v-alert>
          <v-layout row wrap align-center>
            <v-flex xs10>
              <v-combobox
                v-model="shareEmailInput"
                :search-input.sync="shareEmailSearchText"
                :items="empleados"
                item-text="id_usuario.email"
                item-value="id_usuario.email"
                label="Correo electrónico"
                outlined
                dense
                prepend-icon="email"
                @keyup.enter="addShareEmail"
                @change="addShareEmail"
                :filter="customFilterEmpleados"
              >
                <template v-slot:item="data">
                  {{ data.item.id_usuario.first_name }} {{ data.item.id_usuario.last_name }} - {{ data.item.id_usuario.email }}
                </template>
              </v-combobox>
            </v-flex>
            <v-flex xs2 class="pl-2">
              <v-btn icon color="primary" @click="addShareEmail" class="mt-0 mb-3">
                <v-icon>add</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-chip
                v-for="(email, index) in shareEmails"
                :key="index"
                close
                @input="removeShareEmail(index)"
                class="mr-2 mb-2"
                color="primary lighten-4"
                text-color="primary"
            >
                {{ email }}
            </v-chip>
          </v-layout>
        </v-card-text>
        <v-card-actions class="pa-4 bg-light">
          <v-spacer></v-spacer>
          <v-btn text color="grey darken-1" @click="dialogShareProgram = false">Cancelar</v-btn>
          <v-btn
            color="primary"
            depressed
            class="px-6 font-weight-bold"
            style="border-radius: 8px;"
            :loading="loadingShareProgram"
            @click="generateAndShareProgram"
            :disabled="shareEmails.length === 0"
          >
            Enviar
            <v-icon right>send</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog for Sending Evidence -->
    <v-dialog v-model="dialogSendEvidence" max-width="500px">
      <v-card class="rounded-xl overflow-hidden">
        <v-toolbar flat dark color="primary">
          <v-icon left>email</v-icon>
          <v-toolbar-title class="font-weight-bold">Enviar Evidencia por Correo</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogSendEvidence = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pa-4">
          <v-alert :value="true" type="info" outline icon="info" class="mb-4">
            Ingresa los correos electrónicos a los que deseas enviar la evidencia del embarque.
          </v-alert>
          <v-layout row wrap align-center>
            <v-flex xs10>
              <v-text-field
                v-model="evidenceEmailInput"
                label="Correo electrónico"
                outlined
                dense
                prepend-icon="email"
                @keyup.enter="addEvidenceEmail"
              ></v-text-field>
            </v-flex>
            <v-flex xs2 class="pl-2">
              <v-btn icon color="primary" @click="addEvidenceEmail" class="mt-0 mb-3">
                <v-icon>add</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-chip
                v-for="(email, index) in evidenceEmails"
                :key="index"
                close
                @input="removeEvidenceEmail(index)"
                class="mr-2 mb-2"
                color="primary lighten-4"
                text-color="primary"
            >
                {{ email }}
            </v-chip>
          </v-layout>
        </v-card-text>
        <v-card-actions class="pa-4 bg-light">
          <v-spacer></v-spacer>
          <v-btn text color="grey darken-1" @click="dialogSendEvidence = false">Cancelar</v-btn>
          <v-btn
            color="primary"
            depressed
            class="px-6 font-weight-bold"
            style="border-radius: 8px;"
            :loading="loadingSendEvidence"
            @click="sendEvidence"
          >
            Enviar
            <v-icon right>send</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogCalendario" max-width="1200px">
      <v-card>
        <v-toolbar dark color="primary">
            <v-toolbar-title>
                Calendario por Día 
            </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <p class="text-xs-center mt-4">Vista detallada del calendario</p>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="dialogCalendario = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogClientes" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Capturar Datos del Nuevo Cliente</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-text-field v-model="client.name" label="Nombre del Cliente" :rules="[v => !!v || 'El nombre es requerido']" color="primary"></v-text-field>
            <v-text-field v-model="client.address" label="Domicilio" :rules="[v => !!v || 'El domicilio es requerido']" color="primary"></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" flat @click="dialogClientes = false">Cancelar</v-btn>
          <v-btn color="primary" flat @click="guardarCliente">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogEventDetails" max-width="450px" v-if="selectedEvent">
      <v-card class="rounded-xl elevation-8 overflow-hidden">
        <v-toolbar flat dark :class="getToolbarClass(selectedEvent.title)" class="premium-toolbar">
          <v-icon left>info</v-icon>
          <v-toolbar-title class="font-weight-bold">Detalle de la Ventana</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogEventDetails = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-6 mt-2" style="max-height: 65vh; overflow-y: auto;">
          <v-layout column>
            <v-flex class="mb-4 text-center">
              <v-chip
                :class="getMovimientoChipClass(selectedEvent.title)"
                label
                class="px-4 font-weight-bold headline mb-2"
                style="height: auto; padding: 8px 16px; border-radius: 12px;"
              >
                {{ selectedEvent.title }}
              </v-chip>
              <div class="grey--text text--darken-1 font-weight-medium">Estado de la Ventana</div>
              <v-chip
                v-if="selectedEvent.tipo_movimiento_display && enableAdvancedShipments"
                :class="getMovimientoChipClass(selectedEvent.title)"
                small
                class="mt-3 px-3 font-weight-bold"
                style="border-radius: 12px;"
              >
                {{ selectedEvent.tipo_movimiento_display }}
              </v-chip>
            </v-flex>

            <v-divider class="mb-5"></v-divider>

            <v-layout row wrap class="info-grid overflow-hidden">
              <!-- Основная информация (Grid) -->
              <v-flex xs6 class="mb-4 pr-2">
                <div class="d-flex align-start border-right-light h-100">
                  <v-icon color="primary" class="mr-3 mt-1">calendar_today</v-icon>
                  <div>
                    <div class="caption grey--text font-weight-bold text-uppercase">Fecha</div>
                    <div class="body-2 font-weight-bold">{{ selectedEvent.date.split('-').reverse().join('/') }}</div>
                  </div>
                </div>
              </v-flex>

              <v-flex xs6 class="mb-4 pl-2">
                <div class="d-flex align-start h-100">
                  <v-icon color="primary" class="mr-3 mt-1">access_time</v-icon>
                  <div>
                    <div class="caption grey--text font-weight-bold text-uppercase">Hora</div>
                    <div class="body-2 font-weight-bold">{{ selectedEvent.time }}</div>
                  </div>
                </div>
              </v-flex>

              <v-flex xs6 class="mb-4 pr-2" v-if="selectedEvent.client_name || selectedEvent.client">
                <div class="d-flex align-start border-right-light h-100">
                  <v-icon color="primary" class="mr-3 mt-1">person</v-icon>
                  <div>
                    <div class="caption grey--text font-weight-bold text-uppercase">Cliente</div>
                    <div class="body-2 font-weight-bold">{{ selectedEvent.client_name || selectedEvent.client }}</div>
                  </div>
                </div>
              </v-flex>

              <v-flex xs6 class="mb-4 pl-2" v-if="selectedEvent.transport_type_name || selectedEvent.transport_type">
                <div class="d-flex align-start h-100">
                  <v-icon color="primary" class="mr-3 mt-1">local_shipping</v-icon>
                  <div>
                    <div class="caption grey--text font-weight-bold text-uppercase">Transporte</div>
                    <div class="body-2 font-weight-bold">{{ selectedEvent.transport_type_name || selectedEvent.transport_type }}</div>
                  </div>
                </div>
              </v-flex>

              <v-flex xs6 class="mb-4 pr-2">
                <div class="d-flex align-start border-right-light h-100">
                  <v-icon color="primary" class="mr-3 mt-1">timer</v-icon>
                  <div>
                    <div class="caption grey--text font-weight-bold text-uppercase">Duración</div>
                    <div class="body-2 font-weight-bold">{{ selectedEvent.duration }} min</div>
                  </div>
                </div>
              </v-flex>

              <v-flex xs6 class="mb-4 pl-2">
                <div class="d-flex align-start h-100">
                  <v-icon color="primary" class="mr-3 mt-1">forklift</v-icon>
                  <div>
                    <div class="caption grey--text font-weight-bold text-uppercase">Área de Carga</div>
                    <div class="body-2 font-weight-bold">{{ selectedEvent.loading_area_name }}</div>
                  </div>
                </div>
              </v-flex>

              <v-flex xs6 class="mb-4 pl-2" v-if="selectedEvent.company_name || selectedEvent.empresa">
                <div class="d-flex align-start h-100">
                  <v-icon color="primary" class="mr-3 mt-1">business</v-icon>
                  <div>
                    <div class="caption grey--text font-weight-bold text-uppercase">Empresa</div>
                    <div class="body-2 font-weight-bold">{{ selectedEvent.company_name || selectedEvent.empresa }}</div>
                  </div>
                </div>
              </v-flex>

              <v-flex xs6 class="mb-4 pr-2" v-if="selectedEvent.invited_company">
                <div class="d-flex align-start border-right-light h-100">
                  <v-icon color="primary" class="mr-3 mt-1">local_shipping</v-icon>
                  <div>
                    <div class="caption grey--text font-weight-bold text-uppercase">Línea del Transportista</div>
                    <div class="body-2 font-weight-bold">{{ selectedEvent.invited_company }}</div>
                  </div>
                </div>
              </v-flex>

               <!-- Información de Carga (Status EN_PROCESO, LIBERADA o COMPLETADA) -->
              <v-flex xs12 v-if="(selectedEvent.title === 'EN_PROCESO' || selectedEvent.title === 'LIBERADA' || selectedEvent.title === 'COMPLETADA') && currentLoad" class="mt-2">
                <v-divider class="mb-4"></v-divider>
                <v-layout row wrap>
                   <v-flex xs6 class="mb-4 pr-2">
                    <div class="d-flex align-start">
                      <v-icon color="orange" class="mr-3">play_circle_filled</v-icon>
                      <div class="flex-grow-1">
                        <div class="caption grey--text font-weight-bold text-uppercase">Inicio de Carga</div>
                        <div class="body-2 font-weight-bold orange--text">{{ currentLoad.start_time ? new Date(currentLoad.start_time).toLocaleTimeString() : 'N/A' }}</div>
                      </div>
                    </div>
                  </v-flex>

                  <v-flex xs6 class="mb-4 pl-2" v-if="selectedEvent.title === 'LIBERADA' || selectedEvent.title === 'COMPLETADA'">
                    <div class="d-flex align-start">
                      <v-icon :color="selectedEvent.title === 'COMPLETADA' ? 'success' : 'purple'" class="mr-3">stop_circle</v-icon>
                      <div class="flex-grow-1">
                        <div class="caption grey--text font-weight-bold text-uppercase">Fin de Carga</div>
                        <div class="body-2 font-weight-bold mb-2" :class="selectedEvent.title === 'COMPLETADA' ? 'success--text' : 'purple--text'">{{ currentLoad.end_time ? new Date(currentLoad.end_time).toLocaleTimeString() : 'N/A' }}</div>
                      </div>
                    </div>
                  </v-flex>
                </v-layout>

                <div v-if="selectedEvent.title === 'EN_PROCESO' || selectedEvent.title === 'LIBERADA' || selectedEvent.title === 'COMPLETADA'" class="mb-4">
                  <v-btn small depressed color="primary" class="text-none font-weight-bold px-4" @click="agregarEvidencias(selectedEvent)" style="border-radius: 8px;">
                    <v-icon left small>photo_library</v-icon>
                    Ver / Agregar Evidencias
                  </v-btn>
                </div>
                <div v-if="selectedEvent.title === 'EN_PROCESO'" class="mt-4 px-1">
                  <v-text-field
                    v-model="formCarga.payroll_number"
                    label="Número de Nómina"
                    outlined
                    dense
                    prepend-inner-icon="badge"
                    color="primary"
                    placeholder="Ingrese número de nómina"
                    :error-messages="payrollError"
                    @input="payrollError = ''"
                  ></v-text-field>

                  <v-textarea
                    v-model="formCarga.notes"
                    label="Notas de Carga"
                    outlined
                    dense
                    rows="2"
                    prepend-inner-icon="description"
                    color="primary"
                    placeholder="Ingrese observaciones sobre la carga"
                  ></v-textarea>
                </div>

                <!-- Resumen de Carga (Status LIBERADA o COMPLETADA) -->
                <v-card v-if="(selectedEvent.title === 'LIBERADA' || selectedEvent.title === 'COMPLETADA') && currentLoad" flat color="blue-grey lighten-5" class="rounded-lg pa-4 mb-4" style="border: 1px dashed #cfd8dc !important;">
                  <div class="caption blue-grey--text font-weight-bold text-uppercase mb-3 d-flex align-center">
                    <v-icon x-small color="blue-grey" class="mr-2">assignment</v-icon>
                    Resumen de Operación
                  </div>
                  <v-layout column>
                    <v-flex v-if="currentLoad.payroll_number || currentLoad.double_verification_employee_number" class="mb-3">
                      <div class="d-flex align-center">
                        <v-avatar tile size="28" color="white" class="mr-3 elevation-1">
                          <v-icon small color="primary">badge</v-icon>
                        </v-avatar>
                        <div>
                          <div class="caption grey--text font-weight-bold text-uppercase" style="font-size: 0.65rem !important; line-height: 1;">Nómina Verificador</div>
                          <div class="body-2 font-weight-bold primary--text">{{ currentLoad.payroll_number || currentLoad.double_verification_employee_number }}</div>
                        </div>
                      </div>
                    </v-flex>

                    <v-flex v-if="currentLoad.notes">
                      <div class="d-flex align-start">
                        <v-avatar tile size="28" color="white" class="mr-3 elevation-1">
                          <v-icon small color="primary">description</v-icon>
                        </v-avatar>
                        <div class="flex-grow-1">
                          <div class="caption grey--text font-weight-bold text-uppercase" style="font-size: 0.65rem !important; line-height: 1;">Notas de Carga</div>
                          <div class="body-2 font-weight-medium mt-1 grey--text text--darken-4" style="line-height: 1.4;">
                            {{ currentLoad.notes }}
                          </div>
                        </div>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>


              <v-flex xs12 class="mt-2" v-if="selectedEvent.observations">
                <v-divider class="mb-4"></v-divider>
                <div class="d-flex align-start">
                  <v-icon color="primary" class="mr-3">notes</v-icon>
                  <div class="w-100">
                    <div class="caption grey--text font-weight-bold text-uppercase">Observaciones</div>
                    <div class="body-2 font-weight-medium bg-white pa-3 rounded-lg border-light mt-1">
                      {{ selectedEvent.observations }}
                    </div>
                  </div>
                </div>
              </v-flex>

              <!-- Documentos Solicitados (Fusionados) -->
              <v-flex xs12 class="mt-4" v-if="selectedEvent && selectedEvent.required_documents && selectedEvent.required_documents.length > 0">
                <v-divider class="mb-4"></v-divider>
                <div class="d-flex align-start">
                  <v-icon color="primary" class="mr-3">description</v-icon>
                  <div class="w-100">
                    <div class="caption grey--text font-weight-bold text-uppercase mb-3">
                      Documentos Requeridos
                      <span v-if="getPendingDocuments().length > 0" class="amber--text darken-2--text">
                        ({{ getPendingDocuments().length }} pendiente{{ getPendingDocuments().length !== 1 ? 's' : '' }})
                      </span>
                    </div>
                    <v-layout column>
                      <v-flex v-for="doc in documentComparison" :key="doc.id" class="mb-3">
                        <div class="d-flex align-center justify-space-between pa-3 rounded-lg border-light" :style="{ backgroundColor: (doc.status === 'PENDIENTE' || doc.status === 'EXPIRADO') ? '#fff3e0' : '#f5f5f5', borderLeft: (doc.status === 'PENDIENTE' || doc.status === 'EXPIRADO') ? '4px solid #FFA000' : '4px solid #4CAF50' }">
                          <div class="d-flex align-center flex-grow-1">
                            <v-icon
                              :color="doc.status === 'VIGENTE' ? 'success' : (doc.status === 'EXPIRADO' ? 'error' : 'amber darken-2')"
                              small
                              class="mr-2"
                            >
                              {{ doc.status === 'VIGENTE' ? 'check_circle' : (doc.status === 'EXPIRADO' ? 'error_outline' : 'schedule') }}
                            </v-icon>
                            <div>
                              <div class="caption font-weight-bold">{{ doc.name }}</div>
                              <div v-if="doc.status === 'PENDIENTE' && doc.guest_name === 'Sin asignar'" class="caption amber--text darken-2--text font-weight-bold">Pendiente de subir</div>
                              <div v-else class="caption grey--text">{{ doc.guest_name }}<span v-if="doc.guest_email"> - {{ doc.guest_email }}</span></div>
                              <div v-if="doc.valid_until && doc.status === 'EXPIRADO'" class="caption error--text">
                                ⚠️ Venció: {{ new Date(doc.valid_until).toLocaleDateString() }}
                              </div>
                              <div v-if="doc.valid_until && doc.status === 'VIGENTE'" class="caption success--text">
                                ✓ Vence: {{ new Date(doc.valid_until).toLocaleDateString() }}
                              </div>
                            </div>
                          </div>
                          <v-chip
                            small
                            :color="doc.status === 'VIGENTE' ? 'success' : (doc.status === 'EXPIRADO' ? 'error' : 'amber')"
                            text-color="white"
                            label
                            class="ml-2"
                          >
                            {{ doc.status }}
                          </v-chip>
                        </div>
                      </v-flex>
                    </v-layout>
                  </div>
                </div>
              </v-flex>

              <v-flex xs12 class="mt-4" v-if="selectedEvent.administrador || selectedEvent.admin_email">
                <div class="d-flex align-center bg-primary lighten-5 pa-2 rounded-pill pr-4">
                  <v-avatar size="32" color="primary" class="mr-3">
                    <v-icon dark small>admin_panel_settings</v-icon>
                  </v-avatar>
                  <div class="caption primary--text font-weight-bold">
                    Admin: <span class="font-weight-medium">{{ selectedEvent.administrador || selectedEvent.admin_email }}</span>
                  </div>
                </div>
              </v-flex>
            </v-layout>

            <v-alert
              v-if="selectedEvent.title === 'CANCELADA'"
              type="error"
              outline
              color="red"
              class="rounded-lg mt-2"
              icon="block"
            >
              Esta reservación ha sido cancelada.
            </v-alert>
            <v-alert
              v-if="selectedEvent.title === 'PROGRAMADA'"
              type="info"
              outline
              color="blue"
              class="rounded-lg mt-2"
              icon="event_note"
            >
              Esta es una ventana programada pendiente de confirmación.
            </v-alert>
          </v-layout>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4 bg-light">
          <v-layout row wrap fill-height align-center style="width: 100%">
            <v-flex xs12 v-if="selectedEvent.title === 'EN_SITIO'">
              <v-btn block depressed large color="primary" class="text-none font-weight-bold" @click="iniciarCarga(selectedEvent)" style="border-radius: 12px;">
                <v-icon left>play_arrow</v-icon>
                Iniciar Carga
              </v-btn>
            </v-flex>

            <template v-else-if="selectedEvent.title === 'EN_PROCESO'">
              <v-flex xs12 class="mb-2" v-if="faltanEvidenciasRequeridas">
                <v-alert type="error" dense outline icon="warning" class="caption mb-0">No se puede liberar la carga. Faltan evidencias requeridas.</v-alert>
              </v-flex>
              <v-flex xs6 class="pr-2">
                <v-btn block depressed large color="purple" dark class="text-none font-weight-bold" @click="liberarCarga(selectedEvent)" style="border-radius: 12px;" :disabled="faltanEvidenciasRequeridas">
                  <v-icon left>check_circle</v-icon>
                  Liberar Carga
                </v-btn>
              </v-flex>
              <v-flex xs6 class="pl-2 text-xs-right">
                <v-btn block depressed large color="grey lighten-2" class="text-none font-weight-bold" @click="dialogEventDetails = false" style="border-radius: 12px;">
                  Cerrar
                </v-btn>
              </v-flex>
            </template>

            <template v-else-if="selectedEvent.title === 'COMPLETADA'">
              <v-flex xs6 class="pr-2">
                <v-btn block depressed large color="grey lighten-2" class="text-none font-weight-bold" @click="dialogEventDetails = false" style="border-radius: 12px;">
                  Cerrar Ventana
                </v-btn>
              </v-flex>
              <v-flex xs6 class="pl-2">
                <v-btn block depressed large color="primary" class="text-none font-weight-bold" @click="enviarEvidenciaEmail()" :loading="loadingEvidencia" style="border-radius: 12px;" v-if="getProfile.roll == 5 || getProfile.is_superuser" :disabled="!currentLoad || !currentLoad.evidence || currentLoad.evidence.length === 0">
                  <v-icon left>send</v-icon>
                  Enviar evidencia
                </v-btn>
              </v-flex>
            </template>

            <v-flex xs12 v-else>
              <v-btn block depressed large color="grey lighten-2" class="text-none font-weight-bold" @click="dialogEventDetails = false" style="border-radius: 12px;">
                Cerrar Ventana
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo para Agregar Evidencias -->
    <v-dialog v-model="dialogEvidencias" max-width="600px">
      <v-card class="rounded-xl overflow-hidden">
        <v-toolbar flat dark color="primary">
          <v-icon left>photo_library</v-icon>
          <v-toolbar-title class="font-weight-bold">{{ selectedEvent && selectedEvent.title === 'COMPLETADA' ? 'Ver Evidencias' : 'Ver / Agregar Evidencias' }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogEvidencias = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-6">
          <div class="subtitle-1 mb-3 font-weight-bold grey--text text--darken-2">
            Evidencias Requeridas
          </div>
          
        <v-list dense class="mb-4 bg-transparent pa-0">
          <v-card v-for="(ev, idx) in evidenciasEsperadas" :key="idx" class="mb-2 elevation-0" style="border: 1px solid #e0e0e0;">
            <v-list-tile class="py-3 px-3">
              <v-list-tile-content style="overflow: visible;">
                <v-list-tile-title style="white-space: normal; overflow: visible; height: auto; display: flex; align-items: center; flex-wrap: wrap; gap: 4px;">
                  <span>{{ ev.label }}</span>
                  <v-chip v-if="ev.required && !getEvidenciaSubida(ev.label)" x-small color="red" text-color="white" class="font-weight-bold" style="flex-shrink: 0;">Requerido</v-chip>
                  <v-chip v-if="getEvidenciaSubida(ev.label)" x-small color="success" text-color="white" class="font-weight-bold" style="flex-shrink: 0;"><v-icon left x-small>check_circle</v-icon> Subida</v-chip>
                </v-list-tile-title>
              </v-list-tile-content>

              <v-list-tile-action style="flex-direction: row; align-items: center; min-width: 120px; justify-content: flex-end; flex-shrink: 0;">
                <template v-if="getEvidenciaSubida(ev.label)">
                  <v-tooltip top>
                    <v-btn slot="activator" icon small :href="getEvidenciaSubida(ev.label).file" target="_blank" class="mr-1">
                      <v-icon small color="primary">visibility</v-icon>
                    </v-btn>
                    <span>Ver evidencia</span>
                  </v-tooltip>
                  <v-tooltip top v-if="selectedEvent && selectedEvent.title !== 'COMPLETADA'">
                    <v-btn slot="activator" icon small color="error" @click="eliminarEvidencia(getEvidenciaSubida(ev.label).id)">
                      <v-icon small>delete</v-icon>
                    </v-btn>
                    <span>Eliminar evidencia</span>
                  </v-tooltip>
                </template>
                <template v-else>
                  <v-btn v-if="selectedEvent && selectedEvent.title !== 'COMPLETADA'" small color="primary" @click="prepararSubida(ev.label)" :loading="loadingEvidencia && formEvidencia.description === ev.label" depressed outlined>
                    <v-icon left small>cloud_upload</v-icon>
                    Subir
                  </v-btn>
                  <span v-else class="caption text-uppercase grey--text font-weight-bold">Faltante</span>
                </template>
              </v-list-tile-action>
            </v-list-tile>
          </v-card>
          
          <!-- Evidencias Extras Subidas -->
          <v-card v-for="ev in evidenciasExtrasSubidas" :key="'extra-'+ev.id" class="mb-2 elevation-0" style="border: 1px solid #e0e0e0;">
            <v-list-tile class="py-3 px-3">
              <v-list-tile-content style="overflow: visible;">
                <v-list-tile-title style="white-space: normal; overflow: visible; height: auto; display: flex; align-items: center; flex-wrap: wrap; gap: 4px;">
                  <span>{{ ev.description }}</span>
                  <v-chip x-small color="grey" text-color="white" class="font-weight-bold" style="flex-shrink: 0;">Extra</v-chip>
                </v-list-tile-title>
              </v-list-tile-content>

              <v-list-tile-action style="flex-direction: row; align-items: center; min-width: 120px; justify-content: flex-end; flex-shrink: 0;">
                <v-tooltip top>
                  <v-btn slot="activator" icon small :href="ev.file" target="_blank" class="mr-1">
                    <v-icon small color="primary">visibility</v-icon>
                  </v-btn>
                  <span>Ver evidencia</span>
                </v-tooltip>
                <v-tooltip top v-if="selectedEvent && selectedEvent.title !== 'COMPLETADA'">
                  <v-btn slot="activator" icon small color="error" @click="eliminarEvidencia(ev.id)">
                    <v-icon small>delete</v-icon>
                  </v-btn>
                  <span>Eliminar evidencia</span>
                </v-tooltip>
              </v-list-tile-action>
            </v-list-tile>
          </v-card>

        </v-list>
          
          <template v-if="selectedEvent && selectedEvent.title !== 'COMPLETADA'">
            <v-divider class="my-4"></v-divider>
            <div class="subtitle-1 mb-3 font-weight-bold grey--text text--darken-2">
              Evidencias Extras
            </div>
            
            <template v-if="evidenciasExtrasSubidas.length < 2">
              <v-form ref="formEvidenciaExtra">
                <v-layout row wrap align-center>
                  <v-flex xs12 sm5 class="px-1 mb-2">
                    <v-text-field
                      v-model="fileNameExtra"
                      label="Archivo"
                      prepend-icon="attach_file"
                      outlined
                      dense
                      hide-details
                      readonly
                      @click="prepararSubidaExtra"
                      @click:prepend="prepararSubidaExtra"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm5 class="px-1 mb-2">
                    <v-text-field
                      v-model="formEvidenciaExtra.description"
                      label="Descripción"
                      outlined
                      dense
                      hide-details
                      placeholder="ej. Foto Extra 1"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm2 class="px-1 mb-2">
                    <v-btn block color="primary" @click="guardarEvidenciaExtra" :loading="loadingEvidenciaExtra" :disabled="!formEvidenciaExtra.file || !formEvidenciaExtra.description" depressed style="height: 40px;">
                      <v-icon>save</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-form>
            </template>
            <v-alert v-else type="info" outline color="blue" class="rounded-lg mb-0 mt-2" icon="info" :value="true">
              Has alcanzado el límite de 2 evidencias extras permitidas.
            </v-alert>
          </template>

          <!-- Archivos ocultos -->
          <input
            type="file"
            ref="fileInput"
            style="display: none"
            accept="image/*,application/pdf"
            @change="onFileChange"
          >
          <input
            type="file"
            ref="fileInputExtra"
            style="display: none"
            accept="image/*,application/pdf"
            @change="onFileChangeExtra"
          >


        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Confirm Dialog -->
    <v-dialog v-model="dialogConfirm" max-width="400px">
      <v-card class="rounded-xl">
        <v-card-title class="headline font-weight-bold grey lighten-4">Confirmar Acción</v-card-title>
        <v-card-text class="pa-4 body-1">
          ¿Estás seguro de continuar con esta acción?
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn text color="grey darken-1" @click="dialogConfirm = false">Cancelar</v-btn>
          <v-btn color="error" depressed style="border-radius: 8px;" @click="ejecutarConfirmacion">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- REQ-008: Unit Stay Tracking - Unidades Activas -->
    <v-card v-if="enableAdvancedShipments" class="rounded-lg elevation-4 overflow-hidden mt-4">
      <v-toolbar flat color="white" class="border-bottom">
        <v-icon color="primary" class="mr-3">local_shipping</v-icon>
        <v-toolbar-title class="headline font-weight-bold primary--text">
          Unidades Activas en Planta
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          icon
          color="primary"
          @click="loadActiveUnits()"
          :loading="loadingActiveUnits"
          title="Actualizar unidades activas"
        >
          <v-icon>refresh</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider></v-divider>

      <v-card-text class="pa-4">
        <v-progress-linear v-if="loadingActiveUnits" indeterminate></v-progress-linear>

        <table v-if="activeUnits.length > 0" style="width: 100%; border-collapse: collapse;">
          <thead>
            <tr style="background-color: #f5f5f5; border-bottom: 2px solid #ddd;">
              <th style="padding: 12px; text-align: left; font-weight: 600;">Tipo</th>
              <th style="padding: 12px; text-align: left; font-weight: 600;">Placa Unidad</th>
              <th style="padding: 12px; text-align: left; font-weight: 600;">Placa Tracto</th>
              <th style="padding: 12px; text-align: left; font-weight: 600;">Estado</th>
              <th style="padding: 12px; text-align: left; font-weight: 600;">Carga</th>
              <th style="padding: 12px; text-align: left; font-weight: 600;">Tiempo (min)</th>
              <th style="padding: 12px; text-align: left; font-weight: 600;">Llegada</th>
              <th style="padding: 12px; text-align: center; font-weight: 600;">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="unit in activeUnits" :key="unit.id" style="border-bottom: 1px solid #eee;" class="unit-row">
              <td style="padding: 12px;">{{ unit.type }}</td>
              <td style="padding: 12px;">{{ unit.plate }}</td>
              <td style="padding: 12px;">{{ unit.tractor_plate || '-' }}</td>
              <td style="padding: 12px;">
                <v-chip
                  :color="unit.status === 'ARRIVED' ? 'blue' : (unit.status === 'IN_PLANT' ? 'orange' : (unit.status === 'LOADING' || unit.status === 'UNLOADING' ? 'amber' : (unit.status === 'COMPLETED' ? 'green' : 'grey')))"
                  text-color="white"
                  small
                  label
                >
                  {{ getUnitStatusDisplay(unit.status) }}
                </v-chip>
              </td>
              <td style="padding: 12px;">
                <v-chip
                  :color="unit.loading_status === 'COMPLETED' ? 'success' : (unit.loading_status === 'IN PROGRESS' ? 'warning' : 'grey')"
                  text-color="white"
                  x-small
                  label
                >
                  {{ getLoadingStatusDisplay(unit.loading_status) }}
                </v-chip>
              </td>
              <td style="padding: 12px; text-align: center;">{{ unit.time_in_plant_minutes }}</td>
              <td style="padding: 12px; font-size: 0.85rem;">{{ unit.arrival_time ? new Date(unit.arrival_time).toLocaleString('es-MX') : '-' }}</td>
              <td style="padding: 12px; text-align: center;">
                <v-btn
                  v-if="unit.status === 'ARRIVED'"
                  icon
                  x-small
                  color="success"
                  @click="registerArrival(unit)"
                  title="Registrar llegada"
                  class="mr-1"
                >
                  <v-icon x-small>check_circle</v-icon>
                </v-btn>
                <v-btn
                  v-if="unit.status === 'IN_PLANT' || unit.status === 'ARRIVED'"
                  icon
                  x-small
                  color="info"
                  @click="startLoading(unit)"
                  title="Iniciar carga"
                  class="mr-1"
                >
                  <v-icon x-small>play_arrow</v-icon>
                </v-btn>
                <v-btn
                  v-if="unit.status === 'LOADING' || unit.status === 'UNLOADING'"
                  icon
                  x-small
                  color="warning"
                  @click="endLoading(unit)"
                  title="Finalizar carga"
                  class="mr-1"
                >
                  <v-icon x-small>stop_circle</v-icon>
                </v-btn>
                <v-btn
                  v-if="unit.status === 'COMPLETED' || unit.status === 'IN_PLANT' || unit.status === 'LOADING'"
                  icon
                  x-small
                  color="error"
                  @click="registerDeparture(unit)"
                  title="Registrar salida"
                  class="mr-1"
                >
                  <v-icon x-small>exit_to_app</v-icon>
                </v-btn>
                <v-btn
                  icon
                  x-small
                  color="primary"
                  @click="showUnitDetails(unit)"
                  title="Ver detalles"
                >
                  <v-icon x-small>info</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </table>

        <div v-else class="text-center pa-6 grey--text">
          <v-icon large class="mb-2">local_shipping</v-icon>
          <p>No hay unidades activas en este momento</p>
        </div>
      </v-card-text>
    </v-card>

    <!-- Modal de Detalles de Unidad -->
    <v-dialog v-model="dialogUnitDetails" max-width="700px">
      <v-card v-if="selectedUnit">
        <!-- Header con estado visual -->
        <v-toolbar flat color="#002b48" dark>
          <v-icon left large>local_shipping</v-icon>
          <v-toolbar-title class="font-weight-bold">
            {{ selectedUnit.plate }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-chip dark color="rgba(255,255,255,0.2)" class="mr-2">
            <v-icon small left>info</v-icon>
            {{ getUnitStatusDisplay(selectedUnit.status) }}
          </v-chip>
          <v-btn icon @click="dialogUnitDetails = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-6">
          <!-- Información Principal -->
          <v-layout row wrap class="mb-6">
            <v-flex xs12 sm6 class="pa-2">
              <div class="info-card">
                <div class="info-label">
                  <v-icon x-small color="white" class="mr-1">local_shipping</v-icon>
                  Tipo de Unidad
                </div>
                <div class="info-value">{{ selectedUnit.type }}</div>
              </div>
            </v-flex>
            <v-flex xs12 sm6 class="pa-2">
              <div class="info-card">
                <div class="info-label">
                  <v-icon x-small color="white" class="mr-1">confirmation_number</v-icon>
                  Placa
                </div>
                <div class="info-value">{{ selectedUnit.plate }}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm6 class="pa-2" v-if="selectedUnit.tractor_plate">
              <div class="info-card">
                <div class="info-label">
                  <v-icon x-small color="white" class="mr-1">directions_car</v-icon>
                  Tracto Asociado
                </div>
                <div class="info-value">{{ selectedUnit.tractor_plate }}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm6 class="pa-2">
              <div class="info-card">
                <div class="info-label">
                  <v-icon x-small color="white" class="mr-1">speed</v-icon>
                  Estado de Carga
                </div>
                <v-chip
                  :color="selectedUnit.loading_status === 'COMPLETED' ? 'success' : (selectedUnit.loading_status === 'IN PROGRESS' ? 'warning' : 'grey')"
                  text-color="white"
                  x-small
                  label
                  class="mt-2"
                >
                  {{ getLoadingStatusDisplay(selectedUnit.loading_status) }}
                </v-chip>
              </div>
            </v-flex>
          </v-layout>

          <v-divider class="mb-6"></v-divider>

          <!-- Tiempos -->
          <div class="section-title mb-4">
            <v-icon small color="blue" class="mr-2">schedule</v-icon>
            Línea de Tiempo
          </div>

          <v-layout row wrap>
            <v-flex xs12 sm6 class="pa-2">
              <div class="timeline-card arrival">
                <div class="timeline-header">
                  <v-icon small color="blue" class="mr-1">login</v-icon>
                  Llegada
                </div>
                <div class="timeline-time">{{ formatDateTime(selectedUnit.arrival_time) }}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm6 class="pa-2" v-if="selectedUnit.time_in_plant_minutes">
              <div class="timeline-card info">
                <div class="timeline-header">
                  <v-icon small color="white" class="mr-1">schedule</v-icon>
                  Tiempo en Planta
                </div>
                <div class="timeline-time">{{ selectedUnit.time_in_plant_minutes }} minutos</div>
              </div>
            </v-flex>

            <v-flex xs12 sm6 class="pa-2" v-if="selectedUnit.loading_start_time">
              <div class="timeline-card loading">
                <div class="timeline-header">
                  <v-icon small color="orange" class="mr-1">play_circle_filled</v-icon>
                  Inicio de Carga
                </div>
                <div class="timeline-time">{{ formatDateTime(selectedUnit.loading_start_time) }}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm6 class="pa-2" v-if="selectedUnit.loading_end_time">
              <div class="timeline-card">
                <div class="timeline-header">
                  <v-icon small color="green" class="mr-1">stop_circle</v-icon>
                  Fin de Carga
                </div>
                <div class="timeline-time">{{ formatDateTime(selectedUnit.loading_end_time) }}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm6 class="pa-2" v-if="selectedUnit.departure_time">
              <div class="timeline-card departure">
                <div class="timeline-header">
                  <v-icon small color="red" class="mr-1">logout</v-icon>
                  Salida
                </div>
                <div class="timeline-time">{{ formatDateTime(selectedUnit.departure_time) }}</div>
              </div>
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-card-actions class="pa-4 justify-end">
          <v-btn color="primary" depressed @click="dialogUnitDetails = false">
            <v-icon small left>close</v-icon>
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import JSPDF from 'jspdf'
import 'jspdf-autotable'
import '@/plugins/axios'
import store from '@/store'
import {mapGetters, mapState} from 'vuex'

export default {
  data: () => ({
    valid: true,
    menu: false,
    today: new Date().toLocaleDateString(), // '2025-03-31',
    menuVentana: false,
    menuVentana2: false,
    menuVentanaRecurrente: false,
    dialogClientes: false,
    dialogVentana: false,
    dialogCalendario: false,
    eventos: [
        {        
            title: 'PROGRAMADA',
            date: '2025-06-23',
            time: '01:30',
            duration: 30,
        },
        {        
            title: 'EN_PROCESO',
            date: '2025-06-23',
            time: '02:00',
            duration: 30,
        }
    ],
    selected: new Date().toLocaleDateString(), // '2025-03-31',
    documentos: [],
    diasSemana: [
      'Lunes',
      'Martes',
      'Miércoles',
      'Jueves',
      'Viernes',
      'Sábado',
      'Domingo'
    ],
    form: {
      opciones: [],
      fecha: '',
      fechaVentana: '',
      fechaVentanaRecurrente: '',
      hora: '',
      dias: [],
      documentos: [],
      personas: [],
      areas: null,
      client_ids: [],
      address: '',
      loading_time_minutes: '',
      typeTransport: '',
      notas: '',
      empresa: '',
      administrador: ''
    },
    chargeAreas: [],
    clients: [],
    client: {
        code: '',
        name: '',
        address: '',
        loading_time_minutes: ''
    },
    typesOfTransports: [],
    empresas: [
      { id: 1, nombre: 'Transportes y Logística S.A.' },
      { id: 2, nombre: 'Logística Integral S.A. de C.V.' },
      { id: 3, nombre: 'Transporte Express S.A.' },
      { id: 4, nombre: 'Servicios de Carga Rápida S.A.' },
      { id: 5, nombre: 'Logística Avanzada S.A. de C.V.' }
    ],
    administradores: [],
    mostrarCancelados: true,
    dialogShareProgram: false,
    shareEmails: [],
    shareEmailInput: '',
    shareEmailSearchText: '',
    empleados: [],
    loadingShareProgram: false,
    timeInterval: 10,
    numberSlots: 48,
    disabledCalendar: true,
    disabledCalendar2: true,
    disabledCalendar3: true,
    disabledCalendar4: true,
    disabledCalendar5: true,
    disabledCalendar6: true,
    calendars: [],
    id_empresa: '',
    currentDate: null,
    loadingShippingWindows: false,
    id_empresa_empresarial: '',
    admin: {},
    isLoading_empresas: false,
    bandSinAdministrador: false,
    entries2: [],
    search: null,
    errores: [],
    loadingInvitacion: false,
    bandDeleteEvent: false,
    documentationsByCompany: [],
    dialogEventDetails: false,
    dialogEvidencias: false,
    fileName: '',
    formEvidencia: {
      file: null,
      description: ''
    },
    loadingEvidencia: false,
    fileNameExtra: '',
    formEvidenciaExtra: {
      file: null,
      description: ''
    },
    loadingEvidenciaExtra: false,
    shipment_load_id: null,
    currentLoad: null,
    formCarga: {
      payroll_number: '',
      notes: ''
    },
    payrollError: '',
    selectedEvent: null,
    statistics: null,
    dialogSendEvidence: false,
    evidenceEmails: [],
    evidenceEmailInput: '',
    loadingSendEvidence: false,
    dialogConfirm: false,
    confirmCallback: null,
    filtroTipoMovimiento: 'TODOS',
    // REQ-008: Unit Stay Tracking
    activeUnits: [],
    activeUnitsTableKey: 0,
    loadingActiveUnits: false,
    dialogUnitDetails: false,
    selectedUnit: null,
    activeUnitsCount: 0,
    completedUnitsCount: 0,
    totalUnitsCount: 0,
    unitsStatistics: {},
    activeUnitsHeaders: [
      { text: 'Tipo', value: 'type', width: '80px' },
      { text: 'Placa Unidad', value: 'plate', width: '120px' },
      { text: 'Placa Tracto', value: 'tractor_plate', width: '120px' },
      { text: 'Estado', value: 'status', width: '100px' },
      { text: 'Carga', value: 'loading_status', width: '100px' },
      { text: 'Tiempo (min)', value: 'time_in_plant_minutes', width: '100px' },
      { text: 'Llegada', value: 'arrival_time', width: '150px' },
      { text: 'Acciones', value: 'actions', width: '180px', sortable: false }
    ],
    statusColors: {
      'ARRIVED': 'blue',
      'IN_PLANT': 'orange',
      'LOADING': 'amber',
      'UNLOADING': 'amber',
      'COMPLETED': 'green',
      'DEPARTED': 'grey'
    },
    // REQ-006: Documentos requeridos en embarques
    requiredDocuments: [],
    userDocuments: [],
    loadingDocuments: false,
    documentComparison: []
  }),
  created: function(){
    this.getDocumentationByCompany()
    this.get_extra_data()

    this.currentDate = new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10)   // YYYY-MM-DD
    this.form.fechaVentana = this.currentDate
  },
  mounted() {
    this.startAutoRefresh();
    this.get_empleados();
  },
  beforeDestroy() {
    if (this.refreshIntervalId) {
      clearInterval(this.refreshIntervalId);
    }
  },
  computed: {
    ...mapGetters(['getProfile']),
    ...mapState(['language']),
    enableAdvancedShipments() {
      console.log('Verificando acceso a funcionalidades avanzadas de envíos para el usuario...', this.getProfile)
      return this.getProfile && this.getProfile.enable_advanced_shipments === true
    },
    fields () {
      if (!this.id_empresa_empresarial) return []
      return Object.keys(this.id_empresa_empresarial).map(key => {
        return {
          key,
          value: this.id_empresa_empresarial[key] || 'n/a'
        }
      })
      console.log('Se activo....')
      },
      items () {
        return this.entries2.map(entry => {
          const name = entry.name.length > this.descriptionLimit
              ? entry.name.slice(0, this.descriptionLimit) + '...'
              : entry.name

          return Object.assign({}, entry, { name })
        })          
      },
      // convert the list of events into a map of lists keyed by date
      eventsMap () {
        let algo = []
        for (let i = 0; i < this.calendars.length; i++) {
          const map = {}
          const events = this.mostrarCancelados
            ? this.calendars.length > 0 ? this.calendars[i].events : []
            : this.calendars.length > 0 ? this.calendars[i].events.filter(e => e.title !== 'CANCELADA') : [];
          events.forEach(e => (map[e.date] = map[e.date] || []).push(e))
          algo.push(map)
        }
        return algo
      },
      esTransporteCerrado() {
        if (!this.selectedEvent) return false;
        const type = (this.selectedEvent.transport_type_name || this.selectedEvent.transport_type || '').toLowerCase();
        return type.includes('caja seca') || type.includes('contenedor') || type.includes('torton');
      },
      esTransporteAbierto() {
        if (!this.selectedEvent) return false;
        const type = (this.selectedEvent.transport_type_name || this.selectedEvent.transport_type || '').toLowerCase();
        return type.includes('plana') || type.includes('cortina');
      },
      evidenciasEsperadas() {
        // Configuración especial para empresa 86
        if (this.id_empresa === 86) {
          return [
            { label: 'Inicio de carga', required: true },
            { label: 'Carga al 100%', required: true },
          ]
        }

        // Configuración estándar para otras empresas
        if (this.esTransporteCerrado) {
          return [
            { label: 'Foto 1: Inicio carga', required: true },
            { label: 'Foto 2: Carga al 30%', required: true },
            { label: 'Foto 3: Carga al 50%', required: true },
            { label: 'Foto 4: Al 100%', required: true },
          ]
        } else if (this.esTransporteAbierto) {
          return [
            { label: 'Foto 1: Lado izquierdo unidad', required: true },
            { label: 'Foto 2: Derecha unidad', required: true },
            { label: 'Foto 3: Parte trasera carga', required: true },
            { label: 'Foto 4: Amarre de carga', required: true },
          ]
        } else {
          return [
            { label: 'Foto 1: Inicio carga', required: true },
            { label: 'Foto 2: Durante carga', required: true },
            { label: 'Foto 3: Final carga', required: true },
          ]
        }
      },
      evidenciasExtrasSubidas() {
        if (!this.currentLoad || !this.currentLoad.evidence) return [];
        const expectedLabels = this.evidenciasEsperadas.map(e => e.label);
        return this.currentLoad.evidence.filter(e => !expectedLabels.includes(e.description));
      },
      faltanEvidenciasRequeridas() {
        if (!this.currentLoad || !this.currentLoad.evidence) return true;
        return this.evidenciasEsperadas.some(ev => ev.required && !this.currentLoad.evidence.find(e => e.description === ev.label));
      }
  },
  watch: {
      isUpdating (val) {
        if (val) {
            setTimeout(() => (this.isUpdating = false), 3000)
        }
      },
      search (val) {
        console.log(val)
        if (val !== null && val !== undefined) {
          if (val.length > 2) {
            this.isLoading_empresas = true
            const config = {
              method: 'get',
              url: 'https://empresa-service.intrare.app/empresas/filter?search=' + val,
              headers: {
                'Content-Type': 'application/json',
                'authorization': 'Token ' + store.getters.getToken
              }
            };
            axios(config)
              .then(response => {
                console.log(response.data)
                if (this.entries2.length > 0) {
                  for (var i = 0; i < response.data.length; i++) {
                    this.entries2.push(response.data[i])
                  }
                } else
                  this.entries2 = response.data
              })
              .catch(error => {
                console.log(error)
              })
              .finally(() => (this.isLoading_empresas = false))
          }
        }
      }
  },
  methods: {
    get_empleados: function() {
        const config = {
            method: 'get',
            url: 'https://empresa-service.intrare.app/empresas/empleados/',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Token ' + store.getters.getToken
            }
        };
        axios(config)
            .then(response => {
                this.empleados = response.data;
            })
            .catch(error => {
                console.log(error);
            });
    },
    customFilterEmpleados(item, queryText, itemText) {
        if (!queryText) return true;
        
        const firstName = item.id_usuario.first_name ? item.id_usuario.first_name.toLowerCase() : '';
        const lastName = item.id_usuario.last_name ? item.id_usuario.last_name.toLowerCase() : '';
        const email = item.id_usuario.email ? item.id_usuario.email.toLowerCase() : '';
        const searchTerm = queryText.toLowerCase();

        return firstName.includes(searchTerm) || 
               lastName.includes(searchTerm) || 
               email.includes(searchTerm);
    },
    addShareEmail(val) {
        let emailToAdd = typeof val === 'string' ? val : this.shareEmailInput || this.shareEmailSearchText;
        
        if (typeof emailToAdd === 'object' && emailToAdd !== null && emailToAdd.id_usuario) {
            emailToAdd = emailToAdd.id_usuario.email;
        }

        if (emailToAdd && typeof emailToAdd === 'string' && this.isValidEmail(emailToAdd.trim())) {
            let emailClean = emailToAdd.trim();
            if (!this.shareEmails.includes(emailClean)) {
                this.shareEmails.push(emailClean);
            }
            this.$nextTick(() => {
                this.shareEmailInput = null;
                this.shareEmailSearchText = null;
            });
        } else if (emailToAdd && typeof emailToAdd === 'string' && emailToAdd.trim().length > 0) {
            this.$store.commit('snackbar_change_color', 'error');
            this.$store.commit('snackbar_activate_true');
            this.$store.commit('snackbar_change_message', 'Correo inválido');
            setTimeout(this.clear2, 3000);
        }
    },
    removeShareEmail(index) {
        this.shareEmails.splice(index, 1);
    },
    isValidEmail(email) {
        return /.+@.+\..+/.test(email);
    },
    formatDate (dateStr) {
        if (!dateStr) return '';
        const parts = String(dateStr).split('-');
        if (parts.length === 3 && !dateStr.includes('T')) {
            return `${parts[2]}/${parts[1]}/${parts[0]}`;
        }
        const d = new Date(dateStr);
        return `${String(d.getDate()).padStart(2,'0')}/${String(d.getMonth()+1).padStart(2,'0')}/${d.getFullYear()}`;
    },
    formatDateTime (date) {
      const d = new Date(date);
      const day   = String(d.getDate()).padStart(2,'0');
      const month = String(d.getMonth()+1).padStart(2,'0');
      const year  = d.getFullYear();
      const hours = String(d.getHours()).padStart(2,'0');
      const mins  = String(d.getMinutes()).padStart(2,'0');
      return `${day}/${month}/${year} ${hours}:${mins}`;
    },
    async generateAndShareProgram() {
      if (this.shareEmails.length === 0) {
        this.$store.commit('snackbar_change_color', 'error');
        this.$store.commit('snackbar_activate_true');
        this.$store.commit('snackbar_change_message', 'Agrega al menos un correo');
        setTimeout(this.clear2, 3000);
        return;
      }
      this.loadingShareProgram = true;

      try {
        // Collect all scheduled events across all calendars for the specific date
        // and ignore new unasigned slots
        let scheduledEvents = [];
        for (let i = 0; i < this.calendars.length; i++) {
          if (this.calendars[i].events && this.calendars[i].events.length > 0) {
            this.calendars[i].events.forEach(evt => {
              if (evt.date === this.form.fechaVentana && !evt.new) {
                scheduledEvents.push({
                   ...evt,
                   loadingAreaName: this.calendars[i].name
                });
              }
            });
          }
        }

        // Sort events by time
        if (!this.mostrarCancelados) {
          scheduledEvents = scheduledEvents.filter(evt => evt.title !== 'CANCELADA');
        }

        scheduledEvents.sort((a, b) => a.time.localeCompare(b.time));
        console.log('Iniciando creacion de PDFs 1');
        // Generate PDF
        const doc = new JSPDF();
        doc.setFontSize(16);
        doc.text(`Programa de Embarques: ${this.formatDate(this.form.fechaVentana)}`, 14, 20);
        doc.setFontSize(10);
        doc.setTextColor(100);
        doc.text(`Generado el: ${this.formatDateTime(new Date())}`, 14, 28);
          
        const tableColumn = ["Hora", "Andén/Área", "Planta Destino", "Linea transportista", "Transporte", "Estado", "Duración"];
        const tableRows = [];

        scheduledEvents.forEach(evt => {
        const carrierLine = evt.invited_company ||
            'N/A';

          const rowData = [
            evt.time,
            evt.loadingAreaName || 'N/A',
            evt.client_name || 'N/A',
            carrierLine,
            evt.transport_type_name || 'N/A',
            evt.title || 'N/A',
            `${evt.duration || evt.loading_time_minutes} min`
          ];
          tableRows.push(rowData);
        });

        if (tableRows.length === 0) {
           tableRows.push([{ content: 'No hay embarques programados para esta fecha.', colSpan: 7, styles: { halign: 'center' } }]);
        }
        console.log('Iniciando creacion de PDFs 2');
        doc.autoTable({
          head: [tableColumn],
          body: tableRows,
          startY: 40,
          theme: 'grid',
          styles: { fontSize: 8 },
          headStyles: { fillColor: [25, 118, 210] },
          columnStyles: {
            0: { cellWidth: 15 }, // Hora
            1: { cellWidth: 32 }, // Andén/Área
            2: { cellWidth: 'auto' }, // Planta Destino
            3: { cellWidth: 32 }, // Linea del transportista
            4: { cellWidth: 30 }, // Transporte
            5: { cellWidth: 25 }, // Estado
            6: { cellWidth: 18 }  // Duración
          }
        });

        const pageHeight = doc.internal.pageSize.getHeight();
        const pageWidth = doc.internal.pageSize.getWidth();
        doc.setFontSize(8);
        doc.setTextColor(150);
        doc.text('Powered By Intrare', pageWidth / 2, pageHeight - 10, { align: 'center' });

        // Convert the PDF to a Blob
        const pdfBlob = doc.output('blob');
        
        const formData = new FormData();
        this.shareEmails.forEach(email => {
          formData.append('recipient_emails', email);
        });
        formData.append('pdf', pdfBlob, `programa_embarques_${this.form.fechaVentana}.pdf`);
        const config = {
          method: 'post',
          url: 'https://empresa-service.intrare.app/shipments/send-report/',
          headers: {
              'Content-Type': 'multipart/form-data',
              'authorization': 'Token ' + store.getters.getToken
          },
          data: formData
        };

        axios(config)
          .then(response => {
              this.$store.commit('snackbar_change_color', 'success');
              this.$store.commit('snackbar_activate_true');
              this.$store.commit('snackbar_change_message', 'Programa de embarques compartido correctamente.');
              setTimeout(this.clear2, 3000);
              this.dialogShareProgram = false;
              this.shareEmails = [];
          })
          .catch(error => {
              console.error(error);
              this.$store.commit('snackbar_change_color', 'error');
              this.$store.commit('snackbar_activate_true');
              this.$store.commit('snackbar_change_message', 'Error al compartir el programa de embarques.');
              
              doc.save(`programa_embarques_${this.form.fechaVentana}.pdf`);
              this.$store.commit('snackbar_change_color', 'success');
              this.$store.commit('snackbar_change_message', 'Reporte descargado localmente como respaldo.');
              setTimeout(this.clear2, 3000);
              this.dialogShareProgram = false;
          })
          .finally(() => {
              this.loadingShareProgram = false;
          });
      } catch(err) {
        console.error(err);
        this.loadingShareProgram = false;
        this.$store.commit('snackbar_change_color', 'error');
        this.$store.commit('snackbar_activate_true');
        this.$store.commit('snackbar_change_message', 'Error al generar el PDF del programa.');
        setTimeout(this.clear2, 3000);
      }
    },
    getDocumentationByCompany: function(){
      const config = {
        method: 'get',
        url: 'https://empresa-service.intrare.app/documentation/ListCreate/',
        headers: {
            'Content-Type': 'application/json',
            'authorization': 'Token ' + store.getters.getToken
        }
      };
      axios(config)
        .then(response => {
            this.documentationsByCompany = response.data
        })
        .catch(error => {
            console.log(error)
        })
    },
    getStatistics() {
        if (!this.id_empresa) return; // Wait for company ID
        const config = {
            method: 'get',
            url: 'https://empresa-service.intrare.app/shipments/statistics/',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Token ' + store.getters.getToken
            },
            params: {
                empresa_id: this.id_empresa,
                period: 'day',
                date: this.currentDate || moment().format('YYYY-MM-DD')
            }
        };
        axios(config)
            .then(response => {
                this.statistics = response.data.statistics;
            })
            .catch(error => {
                console.log(error);
            });
    },
    customFilterAdministradores (item, queryText) {
      const textOne = item.email.toLowerCase()
      const searchText = queryText.toLowerCase()
      return textOne.indexOf(searchText) > -1
    },
    get_name_company(){
      // console.log('VALOR DE CAMPO = ', this.id_empresa_empresarial)
      for(var i = 0 ; i < this.entries2.length ; i++){
        if(this.entries2[i].id === this.id_empresa_empresarial) {
          // console.log('NAME COMPANY = ', this.entries2[i].name)
          return this.entries2[i].name
        }
      }
    },
    get_managerByCompany: function(id_company){
        console.log(id_company)
        if (id_company !== null && id_company !== undefined) {
            const config = {
                method: 'get',
                url: 'https://empresa-service.intrare.app/empresas/administradoresByCompany/' + id_company,
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Token ' + store.getters.getToken
                }
            };
            axios(config)
                .then(response => {
                    if (response.data.length === 0) {
                        this.admin = {}
                        this.bandSinAdministrador = true
                    } else {
                        this.bandSinAdministrador = false
                    }
                    this.administradores = response.data
                })
                .catch(error => {
                    console.log(error)
                })
        } else {
            this.admin = {}
            this.administradores = []
            this.bandSinAdministrador = false
        }
    },
    async fillRandomCalendars () {
      this.bandDeleteEvent = true
      this.loadingShippingWindows = true
      const config = {
          method: 'get',
          url: 'https://empresa-service.intrare.app/shipments/shipping-windows/by_date_range/',
          headers: {
              'Content-Type': 'application/json',
              'authorization': 'Token ' + store.getters.getToken
          },
          params: {
            start_date: this.currentDate,
            end_date: this.currentDate,
            empresa: this.id_empresa
          }
      };
      try {
        const response = await axios(config)
        const windows = response.data
        if (this.calendars.length > 0) {
          for (let i = 0; i < this.calendars.length; i++) {
            this.calendars[i].events = []
          }
          // Parallel fetch for EN_PROCESO and LIBERADA loads
          const targetWindows = windows.filter(w => w.status === 'EN_PROCESO' || w.status === 'LIBERADA')
          const loadPromises = targetWindows.map(w => this.fetchShipmentLoadData(w.id))
          const loads = await Promise.all(loadPromises)
          const loadsMap = {}
          targetWindows.forEach((win, index) => {
            if (loads[index]) {
              loadsMap[win.id] = loads[index]
            }
          })

          for (let i = 0; i < this.calendars.length; i ++) {
            for (let j = 0; j < windows.length; j++) {
              if(windows[j].loading_area === this.calendars[i].id) {
                const invitedCompanyName = windows[j].invitations && windows[j].invitations.length > 0 && windows[j].invitations[0].invited_company
                  ? windows[j].invitations[0].invited_company.name
                  : null

                this.calendars[i].events.push(
                  {
                    ...windows[j],
                    loading_area_name: this.calendars[i].name,
                    title: windows[j].status,
                    date: windows[j].window_date,
                    time: windows[j].window_time,
                    duration: windows[j].loading_time_minutes,
                    color: this.getStatusColor(windows[j].status),
                    id: windows[j].id,
                    new: false,
                    invited_company: invitedCompanyName,
                    start_time: (loadsMap[windows[j].id] || {}).start_time,
                    end_time: (loadsMap[windows[j].id] || {}).end_time
                  }
                )
              }
            }
          }
        }
        this.loadingShippingWindows = false
        this.dialogVentana = true
      } catch (error) {
          console.log(error)
          this.loadingShippingWindows = false
      }
    },
    async fillCalendars (start_date, end_date) {
      this.loadingShippingWindows = true
      const config = {
          method: 'get',
          url: 'https://empresa-service.intrare.app/shipments/shipping-windows/by_date_range/',
          headers: {
              'Content-Type': 'application/json',
              'authorization': 'Token ' + store.getters.getToken
          },
          params: {
            start_date: start_date,
            end_date: end_date,
            empresa: this.id_empresa
          }
      };
      try {
        const response = await axios(config)
        const windows = response.data
        if (this.calendars.length > 0) {
          for (let i= 0; i< this.calendars.length ;i ++)
            this.calendars[i].events = []
          // Parallel fetch for EN_PROCESO and LIBERADA loads
          const targetWindows = windows.filter(w => w.status === 'EN_PROCESO' || w.status === 'LIBERADA')
          const loadPromises = targetWindows.map(w => this.fetchShipmentLoadData(w.id))
          const loads = await Promise.all(loadPromises)
          const loadsMap = {}
          targetWindows.forEach((win, index) => {
            if (loads[index]) {
              loadsMap[win.id] = loads[index]
            }
          })

          for (let i = 0; i < this.calendars.length; i ++) {
            for (let j = 0; j < windows.length; j++) {
              if(windows[j].loading_area === this.calendars[i].id) {
                const invitedCompanyName = windows[j].invitations && windows[j].invitations.length > 0 && windows[j].invitations[0].invited_company
                  ? windows[j].invitations[0].invited_company.name
                  : null

                this.calendars[i].events.push(
                  {
                    ...windows[j],
                    loading_area_name: this.calendars[i].name,
                    title: windows[j].status,
                    date: windows[j].window_date,
                    time: windows[j].window_time,
                    duration: windows[j].loading_time_minutes,
                    color: this.getStatusColor(windows[j].status),
                    id: windows[j].id,
                    new: false,
                    invited_company: invitedCompanyName,
                    start_time: (loadsMap[windows[j].id] || {}).start_time,
                    end_time: (loadsMap[windows[j].id] || {}).end_time
                  }
                )
              }
            }
          }
        }
        this.loadingShippingWindows = false
        if (this.enableAdvancedShipments) {
          this.loadActiveUnits()
        }
      } catch (error) {
          console.log(error)
          this.loadingShippingWindows = false
      }
    },
    saveDate (date) {
      this.currentDate = date
      this.fillCalendars(this.currentDate, this.currentDate)
      this.getStatistics()
      this.form.fechaVentana = date
    },
    goNext() {
      // Convertir la fecha actual en Date
      const d = new Date(this.currentDate)
      // Avanzar 1 día
      d.setDate(d.getDate() + 1)
      // Volver a colocarla en formato YYYY-MM-DD
      this.currentDate = d.toISOString().substr(0,10)
      this.form.fechaVentana = this.currentDate
      this.form.hora = ''
      this.fillCalendars(this.currentDate, this.currentDate)
      this.getStatistics()
      console.log('Fecha == ', this.currentDate)
    },
    goPrev() {
      // Convertir la fecha actual en Date
      const d = new Date(this.currentDate)
      // Avanzar 1 día
      d.setDate(d.getDate() - 1)
      // Volver a colocarla en formato YYYY-MM-DD
      this.currentDate = d.toISOString().substr(0,10)
      this.form.fechaVentana = this.currentDate
      this.form.hora = ''
      this.fillCalendars(this.currentDate, this.currentDate)
      this.getStatistics()
      console.log('Fecha == ', this.currentDate)
    },
    get_extra_data (){
      const config = {
          method: 'get',
          url: 'https://empresa-service.intrare.app/auth/me',
          headers: {
              'Content-Type': 'application/json',
              'authorization': 'Token ' + store.getters.getToken
          }
      };
      axios(config)
          .then(response => {
            this.id_empresa = response.data.id_company
            this.getStatistics()
            this.getChargeAreas()
            this.getClients()
            this.getTypesOfTransports()
          })
          .catch(error => {
              console.log(error)
          })
    },
    createVCalendars (datos) {
      for (let i = 0; i < datos.length; i++){
        this.calendars.push(
          {
            id: datos[i].id,
            name: datos[i].name,
            focus: "",
            events: []
          }
        )
      }
    },
    getChargeAreas (){
      const config = {
          method: 'get',
          url: 'https://empresa-service.intrare.app/shipments/charge-areas/',
          headers: {
              'Content-Type': 'application/json',
              'authorization': 'Token ' + store.getters.getToken
          },
          params: {
              IdEmpresa: this.id_empresa,
              is_active: true
          }
      };
      axios(config)
          .then(response => {
              this.chargeAreas = response.data
              this.createVCalendars(response.data)
              this.fillCalendars(this.currentDate, this.currentDate)
          })
          .catch(error => {
              console.log(error)
          })
    },
    getClients () {
        const config = {
            method: 'get',
            url: 'https://empresa-service.intrare.app/clients/',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Token ' + store.getters.getToken
            },
            params: {
                empresa: this.id_empresa,
                is_active: true
            }
        };
        axios(config)
            .then(response => {
                this.clients = response.data
            })
            .catch(error => {
                console.log(error)
            })
    },
    getTypesOfTransports (){
      const config = {
        method: 'get',
        url: 'https://empresa-service.intrare.app/shipments/carrier-types/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        },
        params: {
          IdEmpresa: this.id_empresa,
          is_active: true
        }
      };
      axios(config)
      .then(response => {
          this.typesOfTransports = response.data
      })
      .catch(error => {
          console.log(error)
      })
    },
    ejecutarConfirmacion() {
        this.dialogConfirm = false;
        if (this.confirmCallback) {
            this.confirmCallback();
        }
    },
    abrirDialogClientes() {
      this.dialogClientes = true
      this.$refs.form.resetValidation()
      this.limpiarFormulario()
    },
    llenarDialogClientes() {
      this.dialogClientes = true
      this.client = {
        code: this.clients[0].code,
        name: this.clients[0].name,
        address: this.clients[0].address,
        loading_time_minutes: this.clients[0].loading_time_minutes
      }
    },
    guardarCliente() {
      if (this.$refs.form.validate()) {
        console.log('Datos del cliente:', this.client)
        this.$store.commit('snackbar_activate_true');
        this.$store.commit('snackbar_change_message', 'Cliente guardado correctamente');
        this.dialogClientes = false
        this.limpiarFormulario()
      }
    },
    limpiarFormulario() {
      this.client = {
        code: '',
        name: '',
        address: '',
        loading_time_minutes: ''
      }
      this.valid = false
    },
    agregarNewEventoToCalendar({ date, time }, index, id) {
      console.log('Click en el calendario desactivado para creación de eventos');
      // No se genera el evento agregar evento cada vez que de click sobre el calendario
    },
    async open (event) {
      this.selectedEvent = event
      this.currentLoad = null
      this.payrollError = ''
      this.dialogEventDetails = true

      if (event.title === 'PROGRAMADA') {
        this.form.hora = event.time
        this.bandDeleteEvent = false
      }

      if (event.title === 'EN_PROCESO' || event.title === 'LIBERADA' || event.title === 'COMPLETADA') {
        await this.fetchShipmentLoadData(event.id)
      }

      // REQ-006: Cargar TODOS los documentos desde required_documents
      console.log('=== CARGANDO DOCUMENTOS ===')
      console.log('enableAdvancedShipments:', this.enableAdvancedShipments)
      console.log('required_documents:', event.required_documents)

      if (event.required_documents && event.required_documents.length > 0) {
        this.documentComparison = []

        // Iterar sobre required_documents y sus usuarios
        event.required_documents.forEach((doc) => {
          console.log(`Documento: ${doc.name}`, doc.completion_by_user)

          if (doc.completion_by_user && Object.keys(doc.completion_by_user).length > 0) {
            // Para cada usuario que tiene este documento
            Object.keys(doc.completion_by_user).forEach(userId => {
              const userDoc = doc.completion_by_user[userId]
              console.log(`  Usuario ${userDoc.user.name} - Status: ${userDoc.status}`)

              this.documentComparison.push({
                id: doc.id || Math.random().toString(),
                name: doc.name,
                status: userDoc.status,
                valid_until: userDoc.valid_until || null,
                uploaded_at: userDoc.uploaded_at || null,
                uploaded: userDoc.uploaded || false,
                guest_name: userDoc.user.name,
                guest_email: userDoc.user.email,
                required: doc.required
              })
            })
          } else {
            // Si no hay usuarios aún, mostrar el documento como solicitado/pendiente
            this.documentComparison.push({
              id: doc.id || Math.random().toString(),
              name: doc.name,
              status: 'PENDIENTE',
              valid_until: null,
              uploaded_at: null,
              uploaded: false,
              guest_name: 'Sin asignar',
              guest_email: '',
              required: doc.required
            })
          }
        })

        console.log('✅ Documentos cargados total:', this.documentComparison.length)
      } else {
        console.log('❌ No se cargaron documentos')
        this.documentComparison = []
      }

      console.log('=== FIN CARGA DOCUMENTOS ===')
      console.log('documentComparison final:', this.documentComparison)
    },
    // REQ-006: Cargar documentos del usuario
    async loadDocumentsForUser(userId) {
      this.loadingDocuments = true
      const config = {
        method: 'get',
        url: 'https://empresa-service.intrare.app/get-documents-by-user/' + userId + '/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }

      try {
        const response = await axios(config)
        this.userDocuments = response.data || []
        this.documentComparison = this.compareDocuments(this.requiredDocuments, this.userDocuments)
        console.log('Documentos cargados y comparados:', this.documentComparison)
      } catch (error) {
        console.error('Error cargando documentos:', error)
        this.userDocuments = []
        this.documentComparison = this.requiredDocuments.map(doc => ({
          id: doc.id,
          name: doc.name,
          required: doc.required,
          file: null,
          status: 'PENDIENTE'
        }))
      } finally {
        this.loadingDocuments = false
      }
    },
    // REQ-006: Cargar documentos por ID del evento (alternativa)
    async loadDocumentsByEventId(eventId) {
      this.loadingDocuments = true
      const config = {
        method: 'get',
        url: 'https://empresa-service.intrare.app/shipments/' + eventId + '/documents/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }

      try {
        const response = await axios(config)
        const eventData = response.data
        if (eventData && eventData.required_documents) {
          this.requiredDocuments = eventData.required_documents
          this.userDocuments = eventData.user_documents || []
          this.documentComparison = this.compareDocuments(this.requiredDocuments, this.userDocuments)
          console.log('Documentos cargados por evento ID:', this.documentComparison)
        }
      } catch (error) {
        console.error('Error cargando documentos por evento ID:', error)
        this.documentComparison = []
      } finally {
        this.loadingDocuments = false
      }
    },
    // REQ-006: Comparar documentos solicitados con los cargados
    compareDocuments(requiredDocs, userDocs) {
      const comparison = []

      for (let i = 0; i < requiredDocs.length; i++) {
        const reqDoc = requiredDocs[i]
        if (!reqDoc || !reqDoc.id) continue

        let foundUserDoc = null
        for (let j = 0; j < userDocs.length; j++) {
          const userDoc = userDocs[j]
          if (!userDoc || !userDoc.idDocumentation) continue
          if (reqDoc.id === userDoc.idDocumentation.id) {
            foundUserDoc = userDoc
            break
          }
        }

        comparison.push({
          id: reqDoc.id,
          name: reqDoc.name,
          required: reqDoc.required,
          file: foundUserDoc ? foundUserDoc.file : null,
          status: foundUserDoc ? 'LISTO' : 'PENDIENTE'
        })
      }

      return comparison
    },
    getPendingDocuments() {
      return this.documentComparison.filter(doc => doc.status === 'PENDIENTE' || doc.status === 'EXPIRADO')
    },
    onClickInterval(interval) {
      console.log('Intervalo seleccionado:', interval)
    },
    // eliminarEvento(date, index) {
    //   console.log('Fecha del evento a eliminar:', date, index)
    //   // Elimina el evento del arreglo
    //   // Si tienes también el arreglo original eventos2, actualízalo
    //   if (index >= 0){
    //     this.eventos2.splice(index, 1)
    //     this.events2Map[date].splice(index, 1)
    //   }  
    // },
    intervalFormat (interval) {
      // devuelve “00:00, 01:00, … 23:00”
      return interval.time         // usa la versión 24h que ya calcula el calendario
    },
    addMinutesLocal(fechaStr, minutosASumar) {
      const fecha = new Date(fechaStr.toString())
      let fechaNueva = fecha.setMinutes(fecha.getMinutes() + minutosASumar)
      let fechaFinal = new Date(fechaNueva).toLocaleDateString('en-CA', { year: 'numeric', month: '2-digit', day: '2-digit' }) + ' ' + new Date(fechaNueva).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false })
      return fechaFinal
    },
    convertirFecha(fechaStr) {
      // Crear un objeto Date a partir de la cadena en formato "dd/MM/YYYY hh:mm p.m"
      const regex = /(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}) (a\.m\.|p\.m\.)/;
      const matches = fechaStr.match(regex);
      
      if (!matches) {
        throw new Error("El formato de la fecha no es válido.");
      }

      const [_, dia, mes, año, horas, minutos, merid] = matches;

      // Crear un objeto Date con la fecha y hora
      let date = new Date(`${año}-${mes}-${dia}T${horas}:${minutos}:00`);

      // Ajustar la hora según el valor "p.m." o "a.m."
      if (merid === 'p.m.' && date.getHours() < 12) {
        date.setHours(date.getHours() + 12); // Convertir a 24 horas si es "p.m."
      }
      if (merid === 'a.m.' && date.getHours() === 12) {
        date.setHours(0); // Convertir las 12 a.m. a 00:00
      }

      // Formatear la fecha de salida en "YYYY-MM-DD hh:mm"
      const añoFormateado = date.getFullYear();
      const mesFormateado = String(date.getMonth() + 1).padStart(2, '0');
      const diaFormateado = String(date.getDate()).padStart(2, '0');
      const horasFormateado = String(date.getHours()).padStart(2, '0');
      const minutosFormateado = String(date.getMinutes()).padStart(2, '0');

      return `${añoFormateado}-${mesFormateado}-${diaFormateado} ${horasFormateado}:${minutosFormateado}`;
    },
    randomColor () {
      const colors = ['blue', 'red', 'green', 'purple', 'indigo', 'orange']
      return colors[Math.floor(Math.random() * colors.length)]
    },
    sumarMinutos(time, minutos) {
      const fecha = new Date(time)
      fecha.setMinutes(fecha.getMinutes() + minutos)
      console.log('Nueva Fecha:', fecha)
      return fecha.toISOString().slice(0, 10)
    },
    getStatusColor(status) {
      const colors = {
        'PROGRAMADA': '#1976D2', // Blue
        'CONFIRMADA': '#0097A7', // Cyan/Teal
        'EN_SITIO': '#FFA000',   // Amber
        'EN_PROCESO': '#F57C00', // Orange
        'LIBERADA': '#7B1FA2',   // Purple
        'COMPLETADA': '#388E3C', // Green
        'CANCELADA': '#D32F2F'   // Red
      }
      return colors[status] || '#1976D2'
    },
    getStatusClass(status) {
      const classes = {
        'PROGRAMADA': 'programada-event',
        'CONFIRMADA': 'confirmada-event',
        'EN_SITIO': 'ensitio-event',
        'EN_PROCESO': 'enproceso-event',
        'LIBERADA': 'liberada-event',
        'COMPLETADA': 'completada-event',
        'CANCELADA': 'cancelada-event'
      }
      return classes[status] || 'programada-event'
    },
    getMovimientoChipClass(status) {
      const classes = {
        'PROGRAMADA': 'chip-movimiento-programada',
        'CONFIRMADA': 'chip-movimiento-confirmada',
        'EN_SITIO': 'chip-movimiento-ensitio',
        'EN_PROCESO': 'chip-movimiento-enproceso',
        'LIBERADA': 'chip-movimiento-liberada',
        'COMPLETADA': 'chip-movimiento-completada',
        'CANCELADA': 'chip-movimiento-cancelada'
      }
      return classes[status] || 'chip-movimiento-programada'
    },
    getToolbarClass(status) {
      const classes = {
        'PROGRAMADA': 'toolbar-programada',
        'CONFIRMADA': 'toolbar-confirmada',
        'EN_SITIO': 'toolbar-ensitio',
        'EN_PROCESO': 'toolbar-enproceso',
        'LIBERADA': 'toolbar-liberada',
        'COMPLETADA': 'toolbar-completada',
        'CANCELADA': 'toolbar-cancelada'
      }
      return classes[status] || 'toolbar-programada'
    },
    // REQ-006: Verificar si hay documentos pendientes
    hasPendingDocuments(event) {
      if (!this.enableAdvancedShipments) {
        return false
      }

      // Verificar en required_documents si hay documentos pendientes o expirados
      if (event.required_documents && event.required_documents.length > 0) {
        for (let doc of event.required_documents) {
          if (doc.completion_by_user && Object.keys(doc.completion_by_user).length > 0) {
            // Verificar si algún usuario tiene documentos pendiente o expirado
            for (let userId in doc.completion_by_user) {
              const userDoc = doc.completion_by_user[userId]
              if (userDoc.status === 'PENDIENTE' || userDoc.status === 'EXPIRADO') {
                return true
              }
            }
          }
        }
      }
      return false
    },
    isTimeExceeded(event) {
      if ((event.title !== 'EN_PROCESO' && event.title !== 'LIBERADA' && event.title !== 'COMPLETADA') || !event.start_time) return false
      const startTime = new Date(event.start_time)
      const endTime = (event.title === 'LIBERADA' || event.title === 'COMPLETADA') && event.end_time ? new Date(event.end_time) : new Date()
      const loadingTimeMinutes = event.loading_time_minutes || event.duration
      if (!loadingTimeMinutes) return false
      const diffMs = endTime - startTime
      const diffMinutes = diffMs / 60000
      return diffMinutes > loadingTimeMinutes
    },
    shouldShowEvent(event) {
      if (this.filtroTipoMovimiento === 'TODOS') {
        return true
      }
      return (event.tipo_movimiento || 'EMBARQUE') === this.filtroTipoMovimiento
    },
    iniciarCarga(event) {
      console.log('Iniciando carga para el evento:', event)
      const config = {
          method: 'post',
          url: 'https://empresa-service.intrare.app/shipments/shipment-loads/',
          headers: {
              'Content-Type': 'application/json',
              'authorization': 'Token ' + store.getters.getToken
          },
          data: {
              shipping_window: event.id
          }
      };
      axios(config)
          .then(response => {
              // Actualizar el estado localmente
              event.title = 'EN_PROCESO'
              event.color = this.getStatusColor('EN_PROCESO')
              
              this.$store.commit('snackbar_activate_true')
              this.$store.commit('snackbar_change_message', 'Carga iniciada correctamente')
              
              setTimeout(() => {
                  this.dialogEventDetails = false
                  this.$store.commit('snackbar_activate_false')
                  // Recargar calendarios para reflejar cambios reales si es necesario
                  this.fillCalendars(this.currentDate, this.currentDate)
              }, 500)
          })
          .catch(error => {
              console.error('Error al iniciar carga:', error)
              // this.$store.commit('snackbar_activate_true')
              // this.$store.commit('snackbar_change_message', 'Error al iniciar la carga')
          })
    },
    liberarCarga(event) {
      if (!this.currentLoad || !this.currentLoad.id) {
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', 'No se encontró el ID de la carga para liberar')
          return
      }

      if (this.faltanEvidenciasRequeridas) {
          this.$store.commit('snackbar_change_color', 'error')
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', 'No se puede liberar la carga. Faltan evidencias requeridas.')
          setTimeout(this.clear, 3000);
          return
      }

      console.log('Liberando carga:', this.currentLoad.id)
      const config = {
          method: 'post',
          url: 'https://empresa-service.intrare.app/shipments/shipment-loads/' + this.currentLoad.id + '/release_load/',
          headers: {
              'Content-Type': 'application/json',
              'authorization': 'Token ' + store.getters.getToken
          },
          data: {
              id: this.currentLoad.id,
              double_verification_employee_number: this.formCarga.payroll_number,
              notes: this.formCarga.notes
          }
      };
      
      axios(config)
          .then(response => {
              event.title = 'LIBERADA'
              event.color = this.getStatusColor('LIBERADA')
              this.$store.commit('snackbar_activate_true')
              this.$store.commit('snackbar_change_message', 'Carga liberada con éxito')
              
              setTimeout(() => {
                  this.dialogEventDetails = false
                  this.$store.commit('snackbar_activate_false')
                  this.fillCalendars(this.currentDate, this.currentDate)
              }, 500)
          })
          .catch(error => {
              console.error('Error al liberar carga:', error)
              this.payrollError = ''
              
              if (error.response && error.response.status === 400 && error.response.data) {
                // Capturar error específico del campo double_verification_employee_number
                if (error.response.data.error) {
                  this.payrollError = error.response.data.error
                }
              }

              // this.$store.commit('snackbar_activate_true')
              // this.$store.commit('snackbar_change_message', this.payrollError ? 'Hay un error en el número de nómina' : 'Error al liberar la carga')
          })
    },
    async fetchShipmentLoadData(windowId) {
      try {
        const config = {
          method: 'get',
          url: `https://empresa-service.intrare.app/shipments/shipment-loads/by-window/${windowId}/`,
          headers: {
            'authorization': 'Token ' + store.getters.getToken
          }
        }
        const response = await axios(config)
        this.currentLoad = response.data
        if (this.currentLoad && this.currentLoad.id) {
          this.shipment_load_id = this.currentLoad.id
          this.formCarga.payroll_number = this.currentLoad.payroll_number || ''
          this.formCarga.notes = this.currentLoad.notes || ''
        }
        console.log('Datos de la carga actualizados:', this.currentLoad)
        return response.data
      } catch (error) {
        console.error('Error al obtener datos de la carga:', error)
        return null
      }
    },
    async agregarEvidencias(event) {
      console.log('Abriendo interfaz de evidencias para:', event)
      this.selectedEvent = event
      
      const loadData = await this.fetchShipmentLoadData(event.id)
      
      if (loadData && loadData.id) {
        this.formEvidencia.file = null
        this.formEvidencia.description = ''
        this.fileName = ''
        this.dialogEvidencias = true
      } else {
        console.log('No se encontró la carga activa para esta ventana')
        // this.$store.commit('snackbar_activate_true')
        // this.$store.commit('snackbar_change_message', 'No se encontró la carga activa para esta ventana')
      }
    },
    getEvidenciaSubida(label) {
      if (!this.currentLoad || !this.currentLoad.evidence) return null;
      return this.currentLoad.evidence.find(e => e.description === label) || null;
    },
    prepararSubida(label) {
      this.formEvidencia.description = label;
      this.$refs.fileInput.value = '';
      this.$refs.fileInput.click();
    },
    prepararSubidaExtra() {
      this.$refs.fileInputExtra.value = '';
      this.$refs.fileInputExtra.click();
    },
    onFileChange(e) {
      const files = e.target.files
      if (files && files[0]) {
        this.formEvidencia.file = files[0]
        this.fileName = files[0].name
        this.guardarEvidencia()
      } else {
        this.formEvidencia.file = null
        this.fileName = ''
      }
    },
    onFileChangeExtra(e) {
      const files = e.target.files
      if (files && files[0]) {
        this.formEvidenciaExtra.file = files[0]
        this.fileNameExtra = files[0].name
      } else {
        this.formEvidenciaExtra.file = null
        this.fileNameExtra = ''
      }
    },
    guardarEvidencia() {
      if (!this.formEvidencia.file || !this.formEvidencia.description) return

      this.loadingEvidencia = true
      
      const formData = new FormData()
      formData.append('shipment_load', this.shipment_load_id)
      formData.append('file', this.formEvidencia.file)
      formData.append('description', this.formEvidencia.description)

      const config = {
          method: 'post',
          url: 'https://empresa-service.intrare.app/shipments/shipment-load-evidences/',
          headers: {
              'Content-Type': 'multipart/form-data',
              'authorization': 'Token ' + store.getters.getToken
          },
          data: formData
      };

      axios(config)
          .then(async response => {
              this.$store.commit('snackbar_activate_true')
              this.$store.commit('snackbar_change_message', 'Evidencia guardada correctamente')
              this.formEvidencia.file = null
              this.formEvidencia.description = ''
              this.fileName = ''
              
              if (this.selectedEvent) {
                await this.fetchShipmentLoadData(this.selectedEvent.id)
              }
          })
          .catch(error => {
              console.error('Error al guardar evidencia:', error)
          })
          .finally(() => {
              this.loadingEvidencia = false
          })
    },
    guardarEvidenciaExtra() {
      if (!this.formEvidenciaExtra.file || !this.formEvidenciaExtra.description) return
      
      this.loadingEvidenciaExtra = true
      
      const formData = new FormData()
      formData.append('shipment_load', this.shipment_load_id)
      formData.append('file', this.formEvidenciaExtra.file)
      formData.append('description', this.formEvidenciaExtra.description)

      const config = {
          method: 'post',
          url: 'https://empresa-service.intrare.app/shipments/shipment-load-evidences/',
          headers: {
              'Content-Type': 'multipart/form-data',
              'authorization': 'Token ' + store.getters.getToken
          },
          data: formData
      };

      axios(config)
          .then(async response => {
              this.$store.commit('snackbar_activate_true')
              this.$store.commit('snackbar_change_message', 'Evidencia extra guardada correctamente')
              this.formEvidenciaExtra.file = null
              this.formEvidenciaExtra.description = ''
              this.fileNameExtra = ''
              
              if (this.selectedEvent) {
                await this.fetchShipmentLoadData(this.selectedEvent.id)
              }
          })
          .catch(error => {
              console.error('Error al guardar evidencia extra:', error)
          })
          .finally(() => {
              this.loadingEvidenciaExtra = false
          })
    },
    eliminarEvidencia(evId) {
        this.dialogConfirm = true;
        this.confirmCallback = () => {
            const config = {
                method: 'delete',
                url: `https://empresa-service.intrare.app/shipments/shipment-load-evidences/${evId}/`,
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Token ' + store.getters.getToken
                }
            };

            axios(config)
                .then(async response => {
                    this.$store.commit('snackbar_activate_true');
                    this.$store.commit('snackbar_change_message', 'Evidencia eliminada correctamente');
                    if (this.selectedEvent) {
                        await this.fetchShipmentLoadData(this.selectedEvent.id);
                    }
                })
                .catch(error => {
                    console.error('Error al eliminar evidencia:', error);
                    this.$store.commit('snackbar_activate_true');
                    this.$store.commit('snackbar_change_message', 'Error al eliminar evidencia');
                });
        };
    },
    enviarEvidenciaEmail() {
        if (!this.shipment_load_id || !this.currentLoad) {
            console.log('No se encontró información de la carga para enviar');
            return;
        }
        if (!this.currentLoad.evidence || this.currentLoad.evidence.length === 0) {
            this.$store.commit('snackbar_change_color', 'error');
            this.$store.commit('snackbar_activate_true');
            this.$store.commit('snackbar_change_message', 'No hay evidencias asociadas a esta carga');
            setTimeout(this.clear2, 3000);
            return;
        }
        this.dialogSendEvidence = true;
    },
    addEvidenceEmail() {
        if (this.evidenceEmailInput && this.isValidEmail(this.evidenceEmailInput)) {
            this.evidenceEmails.push(this.evidenceEmailInput);
            this.evidenceEmailInput = '';
        } else {
            this.$store.commit('snackbar_change_color', 'error');
            this.$store.commit('snackbar_activate_true');
            this.$store.commit('snackbar_change_message', 'Correo inválido');
            setTimeout(this.clear2, 3000);
        }
    },
    removeEvidenceEmail(index) {
        this.evidenceEmails.splice(index, 1);
    },
    isValidEmail(email) {
        return /.+@.+\..+/.test(email);
    },
    sendEvidence() {
        if (this.evidenceEmails.length === 0) {
            this.$store.commit('snackbar_change_color', 'error');
            this.$store.commit('snackbar_activate_true');
            this.$store.commit('snackbar_change_message', 'Agrega al menos un correo');
            setTimeout(this.clear2, 3000);
            return;
        }
        this.loadingSendEvidence = true;
        const config = {
            method: 'post',
            url: 'https://empresa-service.intrare.app/shipments/send-evidence/',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Token ' + store.getters.getToken
            },
            data: {
                shipment_load_id: this.shipment_load_id,
                recipient_emails: this.evidenceEmails,
                notes: 'Adjunto evidencias de carga.'
            }
        };

        axios(config)
            .then(response => {
                this.loadingSendEvidence = false;
                this.dialogSendEvidence = false;
                this.dialogEventDetails = false;
                this.$store.commit('snackbar_change_color', 'success');
                this.$store.commit('snackbar_change_message', 'Evidencias enviadas correctamente');
                this.$store.commit('snackbar_activate_true');
                setTimeout(this.clear2, 3000);
                this.evidenceEmails = [];
            })
            .catch(error => {
                console.log(error);
                this.loadingSendEvidence = false;
                this.$store.commit('snackbar_change_color', 'error');
                this.$store.commit('snackbar_activate_true');
                this.$store.commit('snackbar_change_message', 'Error al enviar evidencias: ' + (error.response && error.response.data && error.response.data.error ? error.response.data.error : 'Verifica los datos e intenta de nuevo'));
                setTimeout(this.clear2, 3000);
            });
    },


    enviarInvitacion () {
      this.errores = []
      this.loadingInvitacion = true
      let dataToSend = {}
      if (this.documentos.length > 0) {
          dataToSend = {
            empresa: this.id_empresa_empresarial,
            administrador: this.admin === undefined ? '' : this.admin.email,
            loading_area: this.form.areas,
            client_ids: this.form.client_ids,
            window_date: this.form.fechaVentana,
            window_time: this.form.hora,
            transport_type: this.form.typeTransport,
            observations: this.form.notas,
            documentation: this.documentos
          }
      } else {
          dataToSend = {
            empresa: this.id_empresa_empresarial,
            administrador: this.admin === undefined ? '' : this.admin.email,
            loading_area: this.form.areas,
            client_ids: this.form.client_ids,
            window_date: this.form.fechaVentana,
            window_time: this.form.hora,
            transport_type: this.form.typeTransport,
            observations: this.form.notas
          }
      }
      const config = {
        method: 'post',
        url: 'https://empresa-service.intrare.app/shipments/createShipmentReferredInv/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: dataToSend
      };
      axios(config)
        .then(ok => {
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_message', this.$t('mensaje_invitacion_alta'))
            setTimeout(this.clear, 3000);
            this.loadingInvitacion = false
        })
        .catch(error => {
            if (error.response.status == 400
                && typeof error.response.data == "object"
                && error.response.data) { 
                  this.errores = error.response.data
            }
            if (error.response.status === 401) {
                // this.dialogNopay = true
                console.log('No ha pagado el Servico')
            }
            this.loadingInvitacion = false
        })
      console.log('Invitación enviada:', this.form)
    },
    clear: function () {
      this.errores = []
      this.$store.commit('snackbar_activate_false')
      this.clean_fields()
    },
    clear2: function () {
      this.errores = []
      this.$store.commit('snackbar_activate_false')
    },
    clean_fields(){
      this.form = {
        opciones: [],
        fecha: '',
        fechaVentana: '',
        fechaVentanaRecurrente: '',
        hora: '',
        dias: [],
        documentos: [],
        personas: [],
        areas: null,
        client_ids: [],
        address: '',
        loading_time_minutes: '',
        typeTransport: '',
        notas: '',
        empresa: '',
        administrador: ''
      }
      this.documentos = []
      // Campos Invitacion Empresarial
      this.administradores = []
      this.id_empresa_empresarial = ''
      this.admin = {}
      this.bandSinAdministrador = false
    },
    rellenaCamposDireccionDuracionCarga (){
      // Usar el primer cliente seleccionado para obtener dirección y duración
      const primerClienteId = this.form.client_ids && this.form.client_ids.length > 0 ? this.form.client_ids[0] : null
      const clienteSeleccionado = primerClienteId ? this.clients.find(c => c.id === primerClienteId) : null
      if (clienteSeleccionado) {
        this.form.address = clienteSeleccionado.address
        this.form.loading_time_minutes = clienteSeleccionado.loading_time_minutes
        this.llenaCalendario(clienteSeleccionado)
      } else {
        this.form.address = ''
        this.form.loading_time_minutes = ''
      }
    },
    llenaCalendario (client) {
      console.log('Cliente seleccionado para el calendario:', client)
      this.timeInterval = parseInt(client.loading_time_minutes, 10)
      this.numberSlots = 48
    },
    enableCalendar () {
      this.disabledCalendar = this.disabledCalendar2 = this.disabledCalendar3 = this.disabledCalendar4 = this.disabledCalendar5 = this.disabledCalendar6 = true
      const areaSeleccionada = this.chargeAreas.find(c => c.id === this.form.areas)
      console.log('Área seleccionada:', areaSeleccionada)
      if (areaSeleccionada) {
        if (areaSeleccionada.name === 'Andén No. 1') {
          this.disabledCalendar = false
          this.disabledCalendar2 = true
          this.disabledCalendar3 = true
          this.disabledCalendar4 = true
          this.disabledCalendar5 = true
          this.disabledCalendar6 = true
          console.log('Calendario habilitado para Anden No. 1')
        }
        if (areaSeleccionada.name === 'Andén No. 2') {
          this.disabledCalendar = true
          this.disabledCalendar2 = false
          this.disabledCalendar3 = true
          this.disabledCalendar4 = true
          this.disabledCalendar5 = true
          this.disabledCalendar6 = true
          console.log('Calendario habilitado para Anden No. 2')
        }
        if (areaSeleccionada.name === 'Andén No. 3') {
          this.disabledCalendar = true
          this.disabledCalendar2 = true
          this.disabledCalendar3 = false
          this.disabledCalendar4 = true
          this.disabledCalendar5 = true
          this.disabledCalendar6 = true
          console.log('Calendario habilitado para Anden No. 3')
        }
        if (areaSeleccionada.name === 'Rampa n°1') {
          this.disabledCalendar = true
          this.disabledCalendar2 = true
          this.disabledCalendar3 = true
          this.disabledCalendar4 = false
          this.disabledCalendar5 = true
          this.disabledCalendar6 = true
          console.log('Calendario habilitado para Rampa n°1')
        }
        if (areaSeleccionada.name === 'Área de carga de atados n°1 (Puerta 4)') {
          this.disabledCalendar = true
          this.disabledCalendar2 = true
          this.disabledCalendar3 = true
          this.disabledCalendar4 = true
          this.disabledCalendar5 = false
          this.disabledCalendar6 = true
          console.log('Calendario habilitado para Área de carga de atados n°1 (Puerta 4)')
        }
        if (areaSeleccionada.name === 'Área de carga de atados n°2 (Caseta 2-Nave 5)') {
          this.disabledCalendar = true
          this.disabledCalendar2 = true
          this.disabledCalendar3 = true
          this.disabledCalendar4 = true
          this.disabledCalendar5 = true
          this.disabledCalendar6 = false
          console.log('Calendario habilitado para Área de carga de atados n°2 (Caseta 2-Nave 5)')
        }
      }
    },
    generarPDF () {
      const doc = new JSPDF()
      doc.setFontSize(16)
      doc.text('Invitación', 20, 20)
      doc.setFontSize(12)

      doc.text(`📅 Fecha: ${this.form.fecha || 'No definida'}`, 20, 40)
      doc.text(`⏰ Hora: ${this.form.hora || 'No definida'}`, 20, 50)
      doc.text(`🗓️ Días: ${this.form.dias.join(', ') || 'No definidos'}`, 20, 60)
      doc.text(`👥 Invitados: ${this.form.personas.join(', ') || 'Ninguno'}`, 20, 70)
      doc.text('📝 Notas:', 20, 80)

      const lineasNotas = doc.splitTextToSize(this.form.notas || 'Sin notas', 170)
      doc.text(lineasNotas, 20, 90)

      doc.save('invitacion.pdf')
    },
    startAutoRefresh() {
      // Refresh every 2 minutes (120000 ms)
      this.refreshIntervalId = setInterval(() => {
        if (!this.dialogEventDetails) { // Avoid refreshing while a dialog is open
          console.log('Auto-refreshing dashboard data...');
          this.getStatistics();
          this.fillCalendars(this.currentDate, this.currentDate);
          // Recargar unidades activas también
          if (this.enableAdvancedShipments) {
            this.loadActiveUnits();
          }
        }
      }, 120000)
    },
    // REQ-008: Unit Stay Tracking Methods
    loadActiveUnits() {
      this.loadingActiveUnits = true
      const selectedDate = this.form.fechaVentana || this.currentDate
      const internalShippingWindowIds = []

      // Buscar todas las ventanas internas para la fecha seleccionada
      if (this.calendars && this.calendars.length > 0) {
        this.calendars.forEach(calendar => {
          if (calendar.events && calendar.events.length > 0) {
            calendar.events.forEach(event => {
              const hasInternalAssignment = event.assignments &&
                                           event.assignments.length > 0 &&
                                           event.assignments.some(a => a.is_internal === true)

              if (event.date === selectedDate &&
                  event.id &&
                  hasInternalAssignment &&
                  !internalShippingWindowIds.includes(event.id)) {
                internalShippingWindowIds.push(event.id)
              }
            })
          }
        })
      }

      if (internalShippingWindowIds.length === 0) {
        this.activeUnits = []
        this.activeUnitsCount = 0
        this.completedUnitsCount = 0
        this.totalUnitsCount = 0
        this.unitsStatistics = {}
        this.loadingActiveUnits = false
        return
      }

      // Crear peticiones HTTP para cada ventana
      const requests = internalShippingWindowIds.map(shippingWindowId => {
        return axios({
          method: 'post',
          url: 'https://empresa-service.intrare.app/shipments/unit-stay/active/',
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'Token ' + store.getters.getToken
          },
          data: {
            shipping_window_id: shippingWindowId,
            is_internal: true
          }
        })
      })

      // Ejecutar todas las peticiones en paralelo
      Promise.allSettled(requests)
        .then(results => {
          let allActiveUnits = []

          results.forEach((result, index) => {
            if (result.status === 'fulfilled' && result.value.data && result.value.data.active_units) {
              const shippingWindowId = internalShippingWindowIds[index]
              console.log('=== Procesando respuesta del API ===')
              console.log('Índice:', index)
              console.log('ShippingWindowId:', shippingWindowId)
              console.log('Active units del API:', result.value.data.active_units)

              // Agregar shipping_window_id a cada unidad
              const unitsWithWindowId = result.value.data.active_units.map(unit => ({
                ...unit,
                shipping_window_id: shippingWindowId
              }))
              console.log('Units con shipping_window_id agregado:', unitsWithWindowId)
              allActiveUnits = allActiveUnits.concat(unitsWithWindowId)
            }
          })

          // Asignar datos de forma reactiva
          this.activeUnits = Array.from(allActiveUnits)

          // Calcular estadísticas
          this.activeUnitsCount = allActiveUnits.filter(u => ['IN_PLANT', 'ARRIVED', 'LOADING', 'UNLOADING'].includes(u.status)).length
          this.completedUnitsCount = allActiveUnits.filter(u => ['COMPLETED', 'DEPARTED'].includes(u.status)).length
          this.totalUnitsCount = allActiveUnits.length

          if (allActiveUnits.length > 0) {
            const totalTime = allActiveUnits.reduce((sum, unit) => sum + (unit.time_in_plant_minutes || 0), 0)
            this.unitsStatistics = {
              avg_stay_minutes: Math.round(totalTime / allActiveUnits.length),
              units_in_loading: allActiveUnits.filter(u => u.status === 'LOADING' || u.status === 'UNLOADING').length
            }
          } else {
            this.unitsStatistics = {}
          }

          // Forzar renderizado
          this.$nextTick(() => {
            this.activeUnitsTableKey++
          })
        })
        .finally(() => {
          this.loadingActiveUnits = false
        })
    },
    registerArrival(unit) {
      this.loadingActiveUnits = true

      console.log('===== registerArrival INICIADO =====')
      console.log('Unit recibido:', unit)
      console.log('Unit.shipping_window_id:', unit.shipping_window_id)
      console.log('Unit.type:', unit.type)
      console.log('Unit.plate:', unit.plate)
      console.log('Unit.tractor_plate:', unit.tractor_plate)

      // Validar que el unit tenga las propiedades requeridas
      if (!unit) {
        console.error('Unit es null o undefined:', unit)
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_message', 'Error: Unit es inválido')
        this.loadingActiveUnits = false
        return
      }

      if (!unit.shipping_window_id) {
        console.error('Falta shipping_window_id en unit:', unit)
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_message', 'Error: Información de ventana incompleta')
        this.loadingActiveUnits = false
        return
      }

      // Mapear las propiedades correctamente del objeto unit
      // NO incluir tractor_plate si es null para evitar error de validación en el API
      const payload = {
        shipping_window_id: unit.shipping_window_id,
        unit_type: unit.type,
        unit_plate: unit.plate
      }

      // Solo agregar tractor_plate si no es null
      if (unit.tractor_plate) {
        payload.tractor_plate = unit.tractor_plate
      }

      console.log('===== PAYLOAD A ENVIAR =====')
      console.log('Payload:', JSON.stringify(payload))
      console.log('Estructura completa de unit:', unit)

      const config = {
        method: 'post',
        url: 'https://empresa-service.intrare.app/shipments/unit-stay/arrival/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        },
        data: payload
      }

      axios(config)
        .then(response => {
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', 'Llegada registrada exitosamente')
          this.loadActiveUnits()
        })
        .catch(error => {
          console.error('Error registrando llegada:', error)
          console.error('Payload enviado:', payload)
          console.error('Response error data:', error.response && error.response.data)
          this.$store.commit('snackbar_activate_true')
          const errorMsg = (error.response && error.response.data) ?
            (error.response.data.message || JSON.stringify(error.response.data)) :
            'Error al registrar llegada'
          this.$store.commit('snackbar_change_message', errorMsg)
        })
        .finally(() => {
          this.loadingActiveUnits = false
        })
    },
    startLoading(unit) {
      this.loadingActiveUnits = true
      const config = {
        method: 'post',
        url: 'https://empresa-service.intrare.app/shipments/unit-stay/start-loading/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          unit_stay_id: unit.id
        }
      }

      axios(config)
        .then(response => {
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', 'Carga iniciada exitosamente')
          this.loadActiveUnits()
        })
        .catch(error => {
          console.log('Error iniciando carga:', error)
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', (error.response && error.response.data && error.response.data.message) || 'Error al iniciar carga')
        })
        .finally(() => {
          this.loadingActiveUnits = false
        })
    },
    endLoading(unit) {
      this.loadingActiveUnits = true
      const config = {
        method: 'post',
        url: 'https://empresa-service.intrare.app/shipments/unit-stay/end-loading/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          unit_stay_id: unit.id
        }
      }

      axios(config)
        .then(response => {
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', 'Carga finalizada exitosamente')
          this.loadActiveUnits()
        })
        .catch(error => {
          console.log('Error finalizando carga:', error)
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', (error.response && error.response.data && error.response.data.message) || 'Error al finalizar carga')
        })
        .finally(() => {
          this.loadingActiveUnits = false
        })
    },
    registerDeparture(unit) {
      this.loadingActiveUnits = true
      const config = {
        method: 'post',
        url: 'https://empresa-service.intrare.app/shipments/unit-stay/departure/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          unit_stay_id: unit.id
        }
      }

      axios(config)
        .then(response => {
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', 'Salida registrada exitosamente')
          this.loadActiveUnits()
        })
        .catch(error => {
          console.log('Error registrando salida:', error)
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', (error.response && error.response.data && error.response.data.message) || 'Error al registrar salida')
        })
        .finally(() => {
          this.loadingActiveUnits = false
        })
    },
    showUnitDetails(unit) {
      this.selectedUnit = unit
      this.dialogUnitDetails = true
    },
    getStatusColor(status) {
      return this.statusColors[status] || 'grey'
    },
    formatDateTime(dateTime) {
      if (!dateTime) return '-'
      const date = new Date(dateTime)
      return date.toLocaleString('es-MX')
    },
    // REQ-002: Métodos para indicadores visuales de tipo de movimiento
    getMovementBorderColor(event) {
      if (!this.enableAdvancedShipments || !event.tipo_movimiento) return 'transparent'
      return event.tipo_movimiento === 'EMBARQUE' ? '#FFA500' : '#2196F3'
    },
    getMovementClass(event) {
      if (!this.enableAdvancedShipments || !event.tipo_movimiento) return ''
      return 'movement-' + event.tipo_movimiento.toLowerCase()
    },
    // Métodos para traducir estados desde i18n
    getUnitStatusDisplay(status) {
      // Para traducir estados de unidades (ARRIVED, IN_PLANT, etc.)
      const key = status ? status.toUpperCase() : 'UNKNOWN'
      const translation = this.$t(key)
      return translation !== key ? translation : status
    },
    getLoadingStatusDisplay(status) {
      // Para traducir estados de carga (NOT STARTED, IN PROGRESS)
      if (!status) return status
      const key = status.replace(/\s+/g, '_')
      const translation = this.$t(key)
      return translation !== key ? translation : status
    }
  }
}
</script>
<style scoped>
  .border-bottom {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
  }
  .border-right {
    border-right: 1px solid rgba(0, 0, 0, 0.08) !important;
  }
  .border-left {
    border-left: 1px solid rgba(0, 0, 0, 0.08) !important;
  }
  .pointer {
    cursor: pointer;
  }

  .date-display {
    transition: background-color 0.3s;
  }
  .date-display:hover {
    background-color: var(--v-primary-lighten4) !important;
  }

  .legend-box {
    width: 14px;
    height: 14px;
    border-radius: 3px;
  }

  .calendar-container-wrapper {
    max-height: 600px;
    overflow-y: auto;
    overflow-x: auto;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 8px;
  }

  .calendar-grid {
    min-width: 800px; /* Asegura que las columnas no se colapsen demasiado */
    display: flex;
    flex-wrap: nowrap;
  }

  /* Estilos para chips de tipo de movimiento con estados */
  .chip-movimiento-programada {
    background-color: #1976D2 !important;
    color: white !important;
  }

  .chip-movimiento-confirmada {
    background-color: #0097A7 !important;
    color: white !important;
  }

  .chip-movimiento-ensitio {
    background-color: #FFA000 !important;
    color: white !important;
  }

  .chip-movimiento-enproceso {
    background-color: #F57C00 !important;
    color: white !important;
  }

  .chip-movimiento-liberada {
    background-color: #7B1FA2 !important;
    color: white !important;
  }

  .chip-movimiento-completada {
    background-color: #388E3C !important;
    color: white !important;
  }

  .chip-movimiento-cancelada {
    background-color: #D32F2F !important;
    color: white !important;
  }

  /* Estilos para toolbar del modal con estados */
  .toolbar-programada {
    background-color: #1976D2 !important;
  }

  .toolbar-confirmada {
    background-color: #0097A7 !important;
  }

  .toolbar-ensitio {
    background-color: #FFA000 !important;
  }

  .toolbar-enproceso {
    background-color: #F57C00 !important;
  }

  .toolbar-liberada {
    background-color: #7B1FA2 !important;
  }

  .toolbar-completada {
    background-color: #388E3C !important;
  }

  .toolbar-cancelada {
    background-color: #D32F2F !important;
  }

  .calendar-column {
    min-width: 150px;
    flex: 1 0 0%;
  }

  .calendar-header-title {
    position: sticky;
    top: 0;
    z-index: 20;
    background-color: #f8faff;
    font-size: 0.85rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .custom-calendar-style {
    background-color: white !important;
  }

  .interval-label {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.03);
  }

  .my-event-folder {
    position: relative;
    cursor: pointer;
    z-index: 10;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    display: flex;
    flex-direction: column;
    padding-top: 20px; /* Space for the bigger tab */
  }

  .my-event-folder:hover {
    filter: brightness(1.1);
    transform: translateY(-2px);
    z-index: 11;
  }

  /* El tab de la carpeta */
  .folder-tab {
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    padding: 2px 10px;
    font-size: 11px;
    font-weight: 800;
    color: white;
    display: flex;
    align-items: center;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    box-shadow: 0 -2px 4px rgba(0,0,0,0.1);
    white-space: nowrap;
    z-index: 2;
  }

  .folder-tab-text {
    letter-spacing: 0.5px;
  }

  /* El cuerpo principal de la carpeta */
  .folder-body {
    flex-grow: 1;
    border-radius: 0 6px 6px 6px;
    border-top-right-radius: 6px; /* Si la pestaña no ocupa todo */
    box-shadow: 0 2px 6px rgba(0,0,0,0.12);
    color: white;
    overflow: hidden;
    position: relative;
    z-index: 1;
  }

  .folder-content {
    padding: 6px 8px;
    width: 100%;
    height: 100%;
  }

  .event-title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .programada-event {
    background: linear-gradient(135deg, #1976D2 0%, #64B5F6 100%);
    border: none;
  }

  .confirmada-event {
    background: linear-gradient(135deg, #0097A7 0%, #4DD0E1 100%);
    border: none;
  }

  .ensitio-event {
    background: linear-gradient(135deg, #FFA000 0%, #FFD54F 100%);
    border: none;
  }

  @keyframes blink {
    0% { opacity: 1; transform: scale(1); }
    50% { opacity: 0.5; transform: scale(1.1); }
    100% { opacity: 1; transform: scale(1); }
  }

  .blink-alert {
    animation: blink 1.2s infinite ease-in-out;
  }

  .enproceso-event {
    background: linear-gradient(135deg, #F57C00 0%, #FFB74D 100%);
    border: none;
    animation: pulse-active 2s infinite;
  }

  .liberada-event {
    background: linear-gradient(135deg, #7B1FA2 0%, #BA68C8 100%);
    border: none;
  }

  .completada-event {
    background: linear-gradient(135deg, #388E3C 0%, #81C784 100%);
    border: none;
  }

  .cancelada-event {
    background: linear-gradient(135deg, #D32F2F 0%, #E57373 100%);
    border: none;
  }

  @keyframes pulse-active {
    0% {
      box-shadow: 0 0 0 0 rgba(245, 124, 0, 0.4);
    }
    70% {
      box-shadow: 0 0 0 10px rgba(245, 124, 0, 0);
    }
    100% {
      box-shadow: 0 0 0 0 rgba(245, 124, 0, 0);
    }
  }

  .with-time {
    position: absolute;
    left: 4px;
    right: 4px;
  }

  /* Custom scrollbar */
  .calendar-container-wrapper::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  .calendar-container-wrapper::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  .calendar-container-wrapper::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 4px;
  }
  .calendar-container-wrapper::-webkit-scrollbar-thumb:hover {
    background: #bbb;
  }

  /* Ocultar lineas de tiempo internas que no necesitamos si usamos intervalos personalizados */
  .theme--light.v-calendar-daily {
    border: none !important;
  }

  .info-grid {
    background-color: #f8faff;
    border-radius: 16px;
    padding: 20px;
  }

  .border-right-light {
    border-right: 1px solid rgba(0, 0, 0, 0.05);
  }

  .bg-light {
    background-color: #f5f7fa;
  }

  .border-light {
    border: 1px solid rgba(0, 0, 0, 0.08) !important;
  }

  .premium-toolbar {
    letter-spacing: 0.5px;
  }

  .unit-row:hover {
    background-color: #fafafa;
  }

  /* Estilos para Modal de Detalles de Unidad */
  .info-card {
    background: #002b48;
    padding: 16px;
    border-radius: 8px;
    border-left: 4px solid #002b48;
    height: 100%;
    transition: all 0.3s ease;
  }

  .info-card:hover {
    box-shadow: 0 4px 12px rgba(0, 43, 72, 0.15);
    transform: translateY(-2px);
    border-left-color: #004d7a;
  }

  .info-label {
    font-size: 0.75rem;
    font-weight: 700;
    color: #ffffff;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    opacity: 0.9;
  }

  .info-value {
    font-size: 1.1rem;
    font-weight: 600;
    color: #ffffff;
    word-break: break-word;
  }

  .section-title {
    font-size: 0.95rem;
    font-weight: 700;
    color: #333;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    display: flex;
    align-items: center;
  }

  .timeline-card {
    background: white;
    border: 2px solid #e0e0e0;
    border-radius: 8px;
    padding: 12px;
    transition: all 0.3s ease;
    position: relative;
  }

  .timeline-card:hover {
    border-color: #002b48;
    box-shadow: 0 2px 8px rgba(0, 43, 72, 0.15);
  }

  .timeline-card.arrival {
    border-left: 4px solid #002b48;
  }

  .timeline-card.loading {
    border-left: 4px solid #ff9800;
  }

  .timeline-card.departure {
    border-left: 4px solid #f44336;
  }

  .timeline-card.info {
    background: #002b48;
    color: white;
    border-left: 4px solid #002b48;
  }

  .timeline-header {
    font-size: 0.85rem;
    font-weight: 600;
    color: #002b48;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    display: flex;
    align-items: center;
    margin-bottom: 6px;
  }

  .timeline-card.info .timeline-header {
    color: #ffffff;
    opacity: 0.9;
  }

  .timeline-time {
    font-size: 0.95rem;
    font-weight: 500;
    color: #002b48;
    font-family: 'Courier New', monospace;
  }

  .timeline-card.info .timeline-time {
    color: #ffffff;
  }
</style>